<template>
  <div class="page-listings">
    <section class="py-5 bs-shadow mobile-top">
      <div data-v-5a90ec03 class="container">
        <h1 class="lh1">Interterritorial Projects</h1>
        <div class="loader teal">
          <div v-bind:class="progressWidth" class="progress-bar">
            <div class="progress-stripes"></div>
            <div class="percentage">{{ progressPercentage }}</div>
          </div>
        </div>

        <transition
          enter-active-class="animated fadeIn

"
          leave-active-class="animated fadeOut"
          :duration="500"
          mode="out-in"
          appear
        >
          <div v-if="step == 1" class="step1" key="step1">
            <div class="listing">
              <h5>
                <span class="teal">Step 1:</span> End User/Customer Information
                <span class="teal">(required)</span>
              </h5>
              <hr />
              <div class="row">
                <div class="col-xs-12 col-md-6 col-12">
                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* Company Name Installed at?</label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Company Name"
                      placeholder="Enter Company Name"
                      v-model="userCompanyName"
                      required
                    />
                  </div>
                  <div
                    class="custom-control form-control-lg custom-checkbox"
                    style="margin-bottom: 1rem"
                  >
                    <input
                      v-model="dupcompname"
                      class="custom-control-input form-control-lg"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault1"
                    />

                    <label
                      class="custom-control-label"
                      for="flexCheckDefault1"
                      style="margin-top: -4px; line-height: 1"
                    >
                      <small
                        id="emailHelp"
                        class="form-text text-muted"
                        style="margin-top: 0"
                        >Use the company name as the project name</small
                      >
                    </label>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* Contact Name</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Contact Name"
                      placeholder="Enter Contact Name"
                      v-model="userContactName"
                      required
                    />
                  </div>

                  <div class="form-group">
                    <label for="exampleFormControlTextarea1">* Address</label>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                      placeholder="Enter Address..."
                      v-model="userAddress"
                      required
                    ></textarea>
                  </div>

                  <div class="form-group">
                    <label for="exampleInputEmail1">* City</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="City"
                      placeholder="Enter City"
                      v-model="userCity"
                      required
                    />
                  </div>
                </div>
                <div class="col-xs-12 col-md-6 col-12">
                  <div class="form-group">
                    <label for="exampleInputEmail1"
                      >* State
                      <small id="emailHelp" class="form-text text-muted"
                        >Two character state abbbreviation</small
                      ></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="State"
                      placeholder="Enter State"
                      :maxlength="statemax"
                      required
                      :value="userState.toUpperCase()"
                      @input="userState = $event.target.value.toUpperCase()"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">* Zip Code</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Zip Code"
                      placeholder="Enter Zip Code"
                      v-model="userZip"
                      required
                      maxlength="5"
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">* Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Phone"
                      placeholder="Enter Phone"
                      v-model="userPhone"
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="exampleInputEmail1">* Email</label>
                    <input
                      type="text"
                      class="form-control"
                      aria-describedby="Email"
                      placeholder="Enter Email"
                      v-model="userEmail"
                      required
                    />
                  </div>

                  <div
                    class="
                      myTest
                      custom-control custom-checkbox
                      form-control-lg
                    "
                  >
                    <input
                      v-model="skip2and3"
                      class="custom-control-input form-control-lg"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label
                      class="custom-control-label"
                      for="flexCheckDefault"
                      style="margin-top: -4px; line-height: 1"
                    >
                      <small
                        id="emailHelp"
                        class="form-text text-muted"
                        style="margin-top: 0"
                        >Skip architect and general contractor
                        information</small
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col col-12">
                  <div
                    class="
                      nav-btns
                      listing-header
                      d-flex
                      align-items-center
                      mt10
                      mb10
                      rounded
                      b-shadow
                    "
                  >
                    <button v-if="this.step === 1" disabled class="mrauto">
                      <i class="material-icons">keyboard_arrow_left</i> Back
                    </button>

                    <button
                      v-else
                      @click.prevent="setPage(step - 1)"
                      class="mrauto"
                    >
                      <i class="material-icons">keyboard_arrow_left</i> Back
                    </button>
                    <button
                      v-if="
                        !this.userCompanyName.length ||
                        !this.userContactName.length ||
                        !this.userAddress.length ||
                        !this.userCity.length ||
                        !this.userState.length ||
                        !this.userZip.length ||
                        !this.userPhone.length ||
                        !this.userEmail.length
                      "
                      disabled
                      class="mlauto"
                    >
                      Next
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>
                    <button
                      v-else-if="skip2and3"
                      @click.prevent="setPage(step + 3)"
                      class="mlauto"
                    >
                      Next
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>

                    <button
                      v-else
                      @click.prevent="setPage(step + 1)"
                      class="mlauto"
                    >
                      Next
                      <i class="material-icons">keyboard_arrow_right</i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="step == 2" class="step2 listing" key="step2">
            <h5>
              <span class="teal">Step 2:</span> Architect Information
              <span class="teal">(optional)</span>
            </h5>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">Architect Company Name</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Company Name"
                    placeholder="Enter Company Name"
                    v-model="architectCompanyName"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">Architect Contact Name</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Contact Name"
                    placeholder="Enter Contact Name"
                    v-model="architectContactName"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >Architect Address</label
                  >
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    v-model="architectAddress"
                  ></textarea>
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">Architect City</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="City"
                    placeholder="Enter City"
                    v-model="architectCity"
                  />
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">Architect State</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="State"
                    placeholder="Enter State"
                    v-model="architectState"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Architect Zip Code</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Zip Code"
                    placeholder="Enter Zip Code"
                    v-model="architectZip"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Architect Phone</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Phone"
                    placeholder="Enter Phone"
                    v-model="architectPhone"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">Architect Email</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Email"
                    placeholder="Enter Email"
                    v-model="architectEmail"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >
                  <button v-if="this.step === 1" disabled class="mrauto">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step - 1)"
                    class="mrauto"
                  >
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-if="this.step === 5" class="mlauto">
                    Submit
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step + 1)"
                    class="mlauto"
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="step == 3" class="step3 listing" key="step3">
            <h5>
              <span class="teal">Step 3:</span> General Contractor Information
              <span class="teal">(optional)</span>
            </h5>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor Company Name</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Company Name"
                    placeholder="Enter Company Name"
                    v-model="contractorCompanyName"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor Contact Name</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Contact Name"
                    placeholder="Enter Contact Name"
                    v-model="contractorContactName"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >General Contractor Address</label
                  >
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    v-model="contractorAddress"
                  ></textarea>
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor City</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="City"
                    placeholder="Enter City"
                    v-model="contractorCity"
                  />
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor State</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="State"
                    placeholder="Enter State"
                    v-model="contractorState"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor Zip Code</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Zip Code"
                    placeholder="Enter Zip Code"
                    v-model="contractorZip"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor Phone</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Phone"
                    placeholder="Enter Phone"
                    v-model="contractorPhone"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >General Contractor Email</label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Email"
                    placeholder="Enter Email"
                    v-model="contractorEmail"
                  />
                  <!--
                  <small
                    id="emailHelp"
                    class="form-text text-muted"
                  >We'll never share your email with anyone else.</small>
                  -->
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >
                  <button v-if="this.step === 1" disabled class="mrauto">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step - 1)"
                    class="mrauto"
                  >
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button v-if="this.step === 5" class="mlauto">
                    Submit
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step + 1)"
                    class="mlauto"
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="step == 4" class="step4 listing" key="step4">
            <h5>
              <span class="teal">Step 4:</span> Job Information
              <span class="teal">(required)</span>
            </h5>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1"
                    >* Job Name
                    <small v-if="dupcompname"
                      >- Use company name for project name is selected on step
                      1</small
                    ></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Job Name"
                    placeholder="Enter Job Name"
                    v-model="jobName"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlTextarea1"
                    >* Job Description</label
                  >
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="3"
                    placeholder="Enter Job Description..."
                    v-model="jobDesc"
                  ></textarea>
                </div>

                <div class="form-group" >
                  <label for="exampleFormControlSelect1">* Products <small>Please select all that apply</small></label>



   <!--               
                  <multiselect
                    v-model="productTypesSelected"
                    placeholder="Products"
                    label="productId"
                    :searchable="false"
                    :options="productTypes"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="false"
                    :preselect-first="false"
                    style="position: relative"
                  >
                    <template slot="selection" slot-scope="{ values, isOpen }">
                      <span
                        class="multiselect__single"
                        v-if="values.length &amp;&amp; !isOpen"
                        >{{ values.length }} products selected</span
                      >
                    </template>
                  </multiselect>
   -->       
   
   
   
   <div style="border: 1px solid #ced4da;border-radius: 0.25rem; transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;">
                  <v-select 
                  multiple 
                  label="productId"
                  v-model="productTypesSelected" 
                  :options="productTypes" 
                  class="style-chooser"
                  placeholder="Choose Products"
                  />
                </div>
                </div>

                <div class="form-group">
                  <label for="exampleInputEmail1">* SSC Net Value</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="SSC Net Value"
                    placeholder="SSC Net Value"
                    v-model="SSCNetValue"
                  />
                </div>
              </div>
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleFormControlSelect1">* Market</label>
                  <select
                    v-model="MarketSelection"
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option
                      disabled
                      v-bind:value="null"
                      class="all-contractors"
                    >
                      Select a market
                    </option>

                    <option>Business</option>
                    <option>Education</option>
                    <option>Government</option>
                    <option>Healthcare</option>
                    <option>Public Safety</option>
                    <option>Museum</option>
                    <option>Agriculture</option>
                  </select>
                </div>
                <!--
                <p>Selected: {{ MarketSelection }}</p>
                -->

                <div id="pickDate1">
                  <div class="form-group">
                    <label for="exampleFormControlTextarea1"
                      >* Order Date</label
                    >
                    <VueDatePicker 
                    v-model="orderDate"
              input-class-name="dp-custom-input"
              :enable-time-picker="false" 
              format="MMM dd yyyy"
                placeholder="From Date"
                wrapperClass="pickthedate"
                :typeable="true"
                style="padding-right: 10px;"
                ></VueDatePicker>
               <!--
                    <datepicker
                      format="MMM dd yyyy"
                      placeholder="Select Order Date"
                      v-model="orderDate"
                      class="form-control"
                      wrapperClass="datepicker1"
                    ></datepicker>
               -->
                  </div>
                </div>
                <div id="pickDate2">
                  <div class="form-group">
                    <label for="exampleFormControlTextarea1">* Ship Date</label>
                    <VueDatePicker 
                    v-model="shipDate"
              input-class-name="dp-custom-input"
              :enable-time-picker="false" 
              format="MMM dd yyyy"
                placeholder="From Date"
                wrapperClass="pickthedate"
                :typeable="true"
                style="padding-right: 10px;"
                ></VueDatePicker>
                <!--
                    <datepicker
                      format="MMM dd yyyy"
                      placeholder="Select Order Date"
                      v-model="shipDate"
                      class="form-control"
                      wrapperClass="datepicker1"
                    ></datepicker>
                -->
                  </div>
                </div>
                <div class="form-group">
                  <label for="exampleFormControlSelect1"
                    >* Lead Sales Person</label
                  >
                  <select
                    v-model="leadSalesPerson"
                    class="form-control"
                    id="exampleFormControlSelect1"
                  >
                    <option :value="null" selected class="all-contractors">
                      Select a lead sales person
                    </option>
                    <option
                      v-for="person in salespeople"
                      :key="person.userId"
                      :value="person.userId"
                    >
                      {{ person.fullName }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >
                  <button v-if="this.step === 1" disabled class="mrauto">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="this.step != 1 && skip2and3"
                    @click.prevent="setPage(step - 3)"
                    class="mrauto"
                  >
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step - 1)"
                    class="mrauto"
                  >
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                  v-if="
                    !(this.jobName?.length) ||
                    !(this.jobDesc?.length) ||
                    this.MarketSelection == null ||
                    !this.SSCNetValue ||
                    !this.orderDate ||
                    !this.shipDate ||
                    this.leadSalesPerson == null
                  "
                    class="mlauto"
                    disabled
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step + 1)"
                    class="mlauto"
                  >
                    Next
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div v-else-if="step == 5" class="step5 listing" key="step5">
            <h5><span class="teal">Step 5:</span> Installation Information</h5>
            <hr />
            <div class="row">
              <div class="col-xs-12 col-md-6 col-12">
                <div class="form-group">
                  <label for="exampleInputEmail1">* State</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="State"
                    placeholder="Enter State"
                    :maxlength="statemax"
                    required
                    :value="userState.toUpperCase()"
                    @input="userState = $event.target.value.toUpperCase()"
                  />
                </div>
                <div class="form-group">
                  <label for="exampleInputEmail1">* County</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="County"
                    placeholder="Enter County"
                    v-model="County"
                  />
                </div>

                <div class="form-group">
                  <label for="exampleFormControlSelect1"
                    >* Area Contractor
                    <small v-if="foundZip"
                      >The zipcode {{ userZip }} matches
                      <span style="text-transform: lowercase !important">{{
                        acFilter.acName
                      }}</span></small
                    ></label
                  >
                  <select
                    class="form-control"
                    id="exampleFormControlSelect1"
                    v-model="acFilter"
                    @change="resetZip()"
                  >
                    <option
                      :value="null"
                      v-if="acFilter == null"
                      selected
                      class="all-contractors"
                    >
                      Area Contractor
                    </option>
                    <option :value="null" v-else class="all-contractors">
                      Area Contractor
                    </option>
                    <option v-for="ac in acs" :key="ac.acid" :value="ac">
                      {{ " " + ac.acName + " (" + ac.acid + ")" }}
                    </option>
                  </select>

                  <div v-if="byStateList.length" style="margin: 0.5rem 0">
                    <p
                      id="emailHelp"
                      class="
                        form-text
                        text-muted
                        animate__animated animate__fadeIn
                      "
                      style="font-style: italic"
                    >
                      It looks like these area contractors serve the State of
                      {{ userState }}:
                    </p>
                    <div>
                      <p
                        id="emailHelp"
                        class="
                          form-text
                          text-muted
                          animate__animated animate__fadeIn
                        "
                        v-for="ac in byStateList"
                        :key="ac.Id"
                        style="color: #00b4b4 !important"
                      >
                        - {{ ac.Name }}
                      </p>
                      <p
                        v-if="byStateList.length && County == ''"
                        id="emailHelp"
                        class="
                          form-text
                          text-muted
                          animate__animated animate__fadeIn
                        "
                        style="font-style: italic"
                      >
                        Try typing in the county and we'll see what we can find!
                      </p>
                    </div>
                  </div>
                  <div v-else>
                    <br />
                    <div class="flex-box-wrap" style="min-height: 100px">
                      <div class="flex-internal">
                        <hollow-dots-spinner
                          :animation-duration="1000"
                          :size="20"
                          :color="'rgb(0, 180, 180)'"
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="byStateList.length && County != ''"
                    style="margin-top: 0.5rem"
                  >
                    <div>
                      <p
                        id="emailHelp"
                        class="
                          form-text
                          text-muted
                          animate__animated animate__fadeIn
                        "
                        v-for="ac in byStateList"
                        :key="ac.Id"
                        style="color: #00b4b4 !important"
                      >
                        - {{ ac.Name }} also has the territory {{ County }}!
                      </p>
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label v-if="acFilter == null" for="exampleInputEmail1"
                    >* Notes to AC</label
                  >
                  <label
                    v-else-if="
                      acFilter != null && acFilter.primaryContact == null
                    "
                    for="exampleInputEmail1"
                    >No contact assigned at {{ acFilter.acName }} <br /><small
                      class="teal"
                      >a notification will not be sent</small
                    ></label
                  >
                  <label v-else for="exampleInputEmail1"
                    >* Notes to {{ acFilter.primaryContact }} at
                    {{ acFilter.acName }}</label
                  >
                  <textarea
                    class="form-control"
                    id="exampleFormControlTextarea1"
                    rows="5"
                    aria-describedby="Notes to AC"
                    placeholder="Notes to AC"
                    v-model="ACnotes"
                  ></textarea>
                </div>
              </div>
              <div
                class="col-xs-12 col-md-6 col-12 lookup-wrapper"
                style="text-align: left;"
              >
               <div class="form-group">
                  <label for="exampleInputEmail1">* Primary Contact at Installing AC</label>
                  <input
                    type="text"
                    class="form-control"
                    aria-describedby="Primary Contact"
                    placeholder="e.g. John Smith, Project Manager"
                    v-model="PrimaryContactName"
                  />
                </div>
               <div id="pickDate1">
                  <div class="form-group">
                    <label for="exampleFormControlTextarea1"
                      >* Date of Conversation</label
                    >
                    <VueDatePicker 
                    v-model="conversationDate"
              input-class-name="dp-custom-input"
              :enable-time-picker="false" 
              format="MMM dd yyyy"
                placeholder="When did you speak with the installing AC?"
                wrapperClass="pickthedate"
                :typeable="true"
                style="padding-right: 10px;"
                ></VueDatePicker>
    
                  </div>
                </div>
                <div style="text-align: center; margin-top: 20px;">
                  <h5>
                    Need to manually look up the area contractor by territory?
                  </h5>
                  <!--
								<img src="@/assets/img/map.jpg" width="80" alt />
                -->
                  <svg
                    class="lookup-svg"
                    xmlns:cc="http://creativecommons.org/ns#"
                    xmlns:dc="http://purl.org/dc/elements/1.1/"
                    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
                    xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
                    xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
                    xmlns:svg="http://www.w3.org/2000/svg"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    version="1.1"
                    id="us-map"
                    preserveAspectRatio="xMinYMin meet"
                    sodipodi:docname="Republican_Party_presidential_primaries_results,_2016.svg"
                    inkscape:version="0.91 r13725"
                    x="0px"
                    y="0px"
                    width="959px"
                    height="593px"
                    viewBox="174 100 959 593"
                    enable-background="new 174 100 959 593"
                    xml:space="preserve"
                  >
                    <sodipodi:namedview
                      borderColor="#666666"
                      objecttolerance="10"
                      pagecolor="#ffffff"
                      borderopacity="1"
                      gridtolerance="10"
                      guidetolerance="10"
                      inkscape:cx="509.19152"
                      inkscape:cy="282.2353"
                      inkscape:zoom="1.2137643"
                      showgrid="false"
                      id="namedview71"
                      inkscape:current-layer="g5"
                      inkscape:window-maximized="1"
                      inkscape:window-y="-8"
                      inkscape:window-x="-8"
                      inkscape:pageopacity="0"
                      inkscape:window-height="1017"
                      inkscape:window-width="1920"
                      inkscape:pageshadow="2"
                    />
                    <g id="g5">
                      <g>
                        <title>Hawaii</title>
                        <path
                          v-on:click="clickState('HI')"
                          id="HI"
                          data-info="<div class='state-name'>State: Hawaii</div>"
                          fill="#7C7C81"
                          d="M407.1,619.3l1.9-3.6l2.3-0.3l0.3,0.8l-2.1,3.1H407.1z M417.3,615.6l6.1,2.6l2.1-0.3l1.6-3.9   l-0.6-3.4l-4.2-0.5l-4,1.8L417.3,615.6z M448,625.6l3.7,5.5l2.4-0.3l1.1-0.5l1.5,1.3l3.7-0.2l1-1.5l-2.9-1.8l-1.9-3.7l-2.1-3.6   l-5.8,2.9L448,625.6z M468.2,634.5l1.3-1.9l4.7,1l0.6-0.5l6.1,0.6l-0.3,1.3l-2.6,1.5l-4.4-0.3L468.2,634.5z M473.5,639.7l1.9,3.9   l3.1-1.1l0.3-1.6l-1.6-2.1l-3.7-0.3V639.7z M480.5,638.5l2.3-2.9l4.7,2.4l4.4,1.1l4.4,2.7v1.9l-3.6,1.8l-4.8,1l-2.4-1.5   L480.5,638.5z M497.1,654.1l1.6-1.3l3.4,1.6l7.6,3.6l3.4,2.1l1.6,2.4l1.9,4.4l4,2.6l-0.3,1.3l-3.9,3.2l-4.2,1.5l-1.5-0.6l-3.1,1.8   l-2.4,3.2l-2.3,2.9l-1.8-0.2l-3.6-2.6l-0.3-4.5l0.6-2.4l-1.6-5.7l-2.1-1.8l-0.2-2.6l2.3-1l2.1-3.1l0.5-1l-1.6-1.8L497.1,654.1z"
                        />
                      </g>

                      <g>
                        <title>Alaska</title>
                        <path
                          v-on:click="clickState('AK')"
                          v-on:mouseover="showState('ALASKA')"
                          v-on:mouseout="clearState()"
                          id="AK"
                          data-info="<div>State: Alaska</div><div>Capital: Juneau</div>"
                          fill="#7C7C81"
                          d="M332.1,553.7l-0.3,85.4l1.6,1l3.1,0.2l1.5-1.1h2.6l0.2,2.9l7,6.8l0.5,2.6l3.4-1.9l0.6-0.2l0.3-3.1   l1.5-1.6l1.1-0.2l1.9-1.5l3.1,2.1l0.6,2.9l1.9,1.1l1.1,2.4l3.9,1.8l3.4,6l2.7,3.9l2.3,2.7l1.5,3.7l5,1.8l5.2,2.1l1,4.4l0.5,3.1   l-1,3.4l-1.8,2.3l-1.6-0.8l-1.5-3.1l-2.7-1.5l-1.8-1.1l-0.8,0.8l1.5,2.7l0.2,3.7l-1.1,0.5l-1.9-1.9l-2.1-1.3l0.5,1.6l1.3,1.8   l-0.8,0.8c0,0-0.8-0.3-1.3-1c-0.5-0.6-2.1-3.4-2.1-3.4l-1-2.3c0,0-0.3,1.3-1,1c-0.6-0.3-1.3-1.5-1.3-1.5l1.8-1.9l-1.5-1.5v-5h-0.8   l-0.8,3.4l-1.1,0.5l-1-3.7l-0.6-3.7l-0.8-0.5l0.3,5.7v1.1l-1.5-1.3l-3.6-6l-2.1-0.5l-0.6-3.7l-1.6-2.9l-1.6-1.1v-2.3l2.1-1.3   l-0.5-0.3l-2.6,0.6l-3.4-2.4l-2.6-2.9l-4.8-2.6l-4-2.6l1.3-3.2v-1.6l-1.8,1.6l-2.9,1.1l-3.7-1.1l-5.7-2.4h-5.5l-0.6,0.5l-6.5-3.9   l-2.1-0.3l-2.7-5.8l-3.6,0.3l-3.6,1.5l0.5,4.5l1.1-2.9l1,0.3l-1.5,4.4l3.2-2.7l0.6,1.6l-3.9,4.4l-1.3-0.3l-0.5-1.9l-1.3-0.8   l-1.3,1.1l-2.7-1.8l-3.1,2.1l-1.8,2.1l-3.4,2.1l-4.7-0.2l-0.5-2.1l3.7-0.6v-1.3l-2.3-0.6l1-2.4l2.3-3.9v-1.8l0.2-0.8l4.4-2.3l1,1.3   h2.7l-1.3-2.6l-3.7-0.3l-5,2.7l-2.4,3.4l-1.8,2.6l-1.1,2.3l-4.2,1.5l-3.1,2.6l-0.3,1.6l2.3,1l0.8,2.1l-2.7,3.2l-6.5,4.2l-7.8,4.2   l-2.1,1.1l-5.3,1.1l-5.3,2.3l1.8,1.3l-1.5,1.5l-0.5,1.1l-2.7-1l-3.2,0.2l-0.8,2.3h-1l0.3-2.4l-3.6,1.3l-2.9,1l-3.4-1.3l-2.9,1.9   h-3.2l-2.1,1.3l-1.6,0.8l-2.1-0.3l-2.6-1.1l-2.3,0.6l-1,1l-1.6-1.1v-1.9l3.1-1.3l6.3,0.6l4.4-1.6l2.1-2.1l2.9-0.6l1.8-0.8l2.7,0.2   l1.6,1.3l1-0.3l2.3-2.7l3.1-1l3.4-0.6l1.3-0.3l0.6,0.5h0.8l1.3-3.7l4-1.5l1.9-3.7l2.3-4.5l1.6-1.5l0.3-2.6l-1.6,1.3l-3.4,0.6   l-0.6-2.4l-1.3-0.3l-1,1l-0.2,2.9l-1.5-0.2l-1.5-5.8l-1.3,1.3l-1.1-0.5l-0.3-1.9l-4,0.2l-2.1,1.1l-2.6-0.3l1.5-1.5l0.5-2.6   l-0.6-1.9l1.5-1l1.3-0.2l-0.6-1.8v-4.4l-1-1l-0.8,1.5h-6.1l-1.5-1.3l-0.6-3.9l-2.1-3.6v-1l2.1-0.8l0.2-2.1l1.1-1.1l-0.8-0.5   l-1.3,0.5l-1.1-2.7l1-5l4.5-3.2l2.6-1.6l1.9-3.7l2.7-1.3l2.6,1.1l0.3,2.4l2.4-0.3l3.2-2.4l1.6,0.6l1,0.6h1.6l2.3-1.3l0.8-4.4   c0,0,0.3-2.9,1-3.4c0.6-0.5,1-1,1-1l-1.1-1.9l-2.6,0.8l-3.2,0.8l-1.9-0.5l-3.6-1.8l-5-0.2l-3.6-3.7l0.5-3.9l0.6-2.4l-2.1-1.8   l-1.9-3.7l0.5-0.8l6.8-0.5h2.1l1,1h0.6l-0.2-1.6l3.9-0.6l2.6,0.3l1.5,1.1l-1.5,2.1l-0.5,1.5l2.7,1.6l5,1.8l1.8-1l-2.3-4.4l-1-3.2   l1-0.8l-3.4-1.9l-0.5-1.1l0.5-1.6l-0.8-3.9l-2.9-4.7l-2.4-4.2l2.9-1.9h3.2l1.8,0.6l4.2-0.2l3.7-3.6l1.1-3.1l3.7-2.4l1.6,1l2.7-0.6   l3.7-2.1l1.1-0.2l1,0.8l4.5-0.2l2.7-3.1h1.1l3.6,2.4l1.9,2.1l-0.5,1.1l0.6,1.1l1.6-1.6l3.9,0.3l0.3,3.7l1.9,1.5l7.1,0.6l6.3,4.2   l1.5-1l5.2,2.6l2.1-0.6l1.9-0.8l4.8,1.9L332.1,553.7z M217,582.6l2.1,5.3l-0.2,1l-2.9-0.3l-1.8-4l-1.8-1.5H210l-0.2-2.6l1.8-2.4   l1.1,2.4l1.5,1.5L217,582.6z M214.4,616.1l3.7,0.8l3.7,1l0.8,1l-1.6,3.7l-3.1-0.2l-3.4-3.6L214.4,616.1z M193.7,602l1.1,2.6   l1.1,1.6l-1.1,0.8l-2.1-3.1V602H193.7z M180,675.1l3.4-2.3l3.4-1l2.6,0.3l0.5,1.6l1.9,0.5l1.9-1.9l-0.3-1.6l2.7-0.6l2.9,2.6   l-1.1,1.8l-4.4,1.1l-2.7-0.5l-3.7-1.1l-4.4,1.5l-1.6,0.3L180,675.1z M228.9,670.6l1.6,1.9l2.1-1.6l-1.5-1.3L228.9,670.6z    M231.8,673.6l1.1-2.3l2.1,0.3l-0.8,1.9H231.8z M255.4,671.7l1.5,1.8l1-1.1l-0.8-1.9L255.4,671.7z M264.2,659.2l1.1,5.8l2.9,0.8   l5-2.9l4.4-2.6l-1.6-2.4l0.5-2.4l-2.1,1.3l-2.9-0.8l1.6-1.1l1.9,0.8l3.9-1.8l0.5-1.5l-2.4-0.8l0.8-1.9l-2.7,1.9l-4.7,3.6l-4.8,2.9   L264.2,659.2z M306.5,639.4l2.4-1.5l-1-1.8l-1.8,1L306.5,639.4z"
                        />
                      </g>

                      <g class="hoverme">
                        <title>Florida</title>
                        <path
                          v-on:click="clickState('FL')"
                          v-on:mousover="showState('FLORIDA')"
                          v-on:mouseout="clearState()"
                          id="FL"
                          data-info="<div>State: Florida</div><div>Capital: Tallahassee</div>"
                          fill="#7C7C81"
                          d="M929.4,545.5l2.3,7.3l3.7,9.7l5.3,9.4l3.7,6.3l4.8,5.5l4,3.7l1.6,2.9l-1.1,1.3L953,593l2.9,7.4   l2.9,2.9l2.6,5.3l3.6,5.8l4.5,8.2l1.3,7.6l0.5,12l0.6,1.8l-0.3,3.4l-2.4,1.3l0.3,1.9l-0.6,1.9l0.3,2.4l0.5,1.9l-2.7,3.2l-3.1,1.5   l-3.9,0.2l-1.5,1.6l-2.4,1l-1.3-0.5l-1.1-1l-0.3-2.9l-0.8-3.4l-3.4-5.2l-3.6-2.3l-3.9-0.3l-0.8,1.3l-3.1-4.4l-0.6-3.6l-2.6-4   l-1.8-1.1l-1.6,2.1l-1.8-0.3l-2.1-5l-2.9-3.9l-2.9-5.3l-2.6-3.1l-3.6-3.7l2.1-2.4l3.2-5.5l-0.2-1.6l-4.5-1l-1.6,0.6l0.3,0.6l2.6,1   l-1.5,4.5l-0.8,0.5l-1.8-4l-1.3-4.8l-0.3-2.7l1.5-4.7v-9.5L910,585l-1.3-3.1l-5.2-1.3l-1.9-0.6l-1.6-2.6l-3.4-1.6l-1.1-3.4l-2.7-1   l-2.4-3.7l-4.2-1.5l-2.9-1.5h-2.6l-4,0.8l-0.2,1.9l0.8,1l-0.5,1.1l-3.1-0.2l-3.7,3.6l-3.6,1.9h-3.9l-3.2,1.3l-0.3-2.7l-1.6-1.9   l-2.9-1.1l-1.6-1.5l-8.1-3.9l-7.6-1.8l-4.4,0.6l-6,0.5l-6,2.1l-3.5,0.6l-0.2-8l-2.6-1.9l-1.8-1.8l0.3-3.1l10.2-1.3l25.5-2.9   l6.8-0.6l5.4,0.3l2.6,3.9l1.5,1.5l8.1,0.5l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l3.8,0.8l0.3-4.8l-1.6-4.5l1-0.7l5.1,0.5   L929.4,545.5z M941.9,677.9l2.4-0.6l1.3-0.2l1.5-2.3l2.3-1.6l1.3,0.5l1.7,0.3l0.4,1.1l-3.5,1.2l-4.2,1.5l-2.3,1.2L941.9,677.9z    M955.4,672.9l1.2,1.1l2.7-2.1l5.3-4.2l3.7-3.9l2.5-6.6l1-1.7l0.2-3.4l-0.7,0.5l-1,2.8l-1.5,4.6l-3.2,5.3l-4.4,4.2l-3.4,1.9   L955.4,672.9z"
                        />
                      </g>

                      <g>
                        <title>South Carolina</title>
                        <path
                          v-on:click="clickState('SC')"
                          v-on:mouseover="showState('South Carolina')"
                          v-on:mouseout="clearState()"
                          id="SC"
                          data-info="<div>State: South Carolina</div><div>Capital: Columbia</div>"
                          fill="#7C7C81"
                          d="M935.2,512.9l-1.8,1l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.7-6l-4.2-1.9   l-2.1-1.9l-1.3-2.6L910,485l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-5.2l-3.4,0.2l-4-2.4l-1.3-1.3   l-0.3-1.8l0.8-1.9l2.3-1l-0.3-2.1l6.1-2.6l9.1-4.5l7.3-0.8l16.5-0.5l2.3,1.9l1.6,3.2l4.4-0.5l12.6-1.5l2.9,0.8l12.6,7.6l10.1,8.1   l-5.4,5.5l-2.6,6.1l-0.5,6.3l-1.6,0.8l-1.1,2.7l-2.4,0.6l-2.1,3.6l-2.7,2.7l-2.3,3.4l-1.6,0.8l-3.6,3.4l-2.9,0.2l1,3.2l-5,5.5   L935.2,512.9z"
                        />
                      </g>

                      <g>
                        <title>Georgia</title>
                        <path
                          v-on:click="clickState('GA')"
                          id="GA"
                          data-info="<div>State: Georgia</div><div>Capital: Atlanta</div>"
                          fill="#7C7C81"
                          d="M863.6,458l-4.8,0.8l-8.4,1.1l-8.6,0.9v2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7   l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l0.6,3.4l2.6,3.9   l1.5,1.5l7.9,0.2l10.8-0.6l21.5-1.3l5.4-0.7l4.6,0l0.2,2.9l2.6,0.8l0.3-4.4l-1.6-4.5l1.1-1.6l5.8,0.8l5,0.3l-0.8-6.3l2.3-10   l1.5-4.2l-0.5-2.6l3.3-6.2l-0.5-1.4l-1.9,0.7l-2.6-1.3l-0.6-2.1l-1.3-3.6l-2.3-2.1l-2.6-0.6l-1.6-4.8l-2.9-6.3l-4.2-1.9l-2.1-1.9   l-1.3-2.6l-2.1-1.9l-2.3-1.3l-2.3-2.9l-3.1-2.3l-4.5-1.8l-0.5-1.5l-2.4-2.9l-0.5-1.5l-3.4-4.9l-3.4,0.2l-4.1-3l-1.3-1.3l-0.3-1.8   l0.8-1.9l2.4-1.2l-1.1-1.2l0.1-0.3l-5.8,1l-7,0.8L863.6,458z"
                        />
                      </g>

                      <g>
                        <title>Alabama</title>
                        <path
                          v-on:click="clickState('AL')"
                          id="AL"
                          data-info="<div>State: Alabama</div><div>Capital: Montgomery</div>"
                          fill="#7C7C81"
                          d="M799.6,566.8l-1.6-15.2l-2.7-18.8l0.2-14.1l0.8-31l-0.2-16.7l0.2-6.4l7.8-0.4l27.8-2.6l8.9-0.7   l-0.1,2.2l0.2,2.1l0.6,3.4l3.4,7.9l2.4,9.9l1.5,6.1l1.6,4.8l1.5,7l2.1,6.3l2.6,3.4l0.5,3.4l1.9,0.8l0.2,2.1l-1.8,4.8l-0.5,3.2   l-0.2,1.9l1.6,4.4l0.3,5.3l-0.8,2.4l0.6,0.8l1.5,0.8l1,2.5h-6.3l-6.8,0.6l-25.5,2.9l-10.4,1.4l-0.1,3.8l1.8,1.8l2.6,1.9l0.6,7.9   l-5.5,2.6l-2.7-0.3l2.7-1.9v-1l-3.1-6l-2.3-0.6l-1.5,4.4l-1.3,2.7l-0.6-0.2H799.6z"
                        />
                      </g>

                      <g>
                        <title>North Carolina</title>
                        <path
                          v-on:click="clickState('NC')"
                          id="NC"
                          data-info="<div>State: North Carolina</div><div>Capital: Raleigh</div>"
                          fill="#7C7C81"
                          d="M1006.1,398.5l1.7,4.7l3.6,6.5l2.4,2.4l0.6,2.3l-2.4,0.2l0.8,0.6l-0.3,4.2l-2.6,1.3l-0.6,2.1   l-1.3,2.9l-3.7,1.6l-2.4-0.3l-1.5-0.2l-1.6-1.3l0.3,1.3v1h1.9l0.8,1.3l-1.9,6.3h4.2l0.6,1.6l2.3-2.3l1.3-0.5l-1.9,3.6l-3.1,4.8   h-1.3l-1.1-0.5l-2.7,0.6l-5.2,2.4l-6.5,5.3l-3.4,4.7l-1.9,6.5l-0.5,2.4l-4.7,0.5l-5.5,1.3l-9.9-8.2l-12.6-7.6l-2.9-0.8l-12.6,1.5   l-4.3,0.8l-1.6-3.2l-3-2.1l-16.5,0.5l-7.3,0.8l-9.1,4.5l-6.1,2.6l-1.6,0.3l-5.8,1l-7,0.8l-6.8,0.5l0.5-4.1l1.8-1.5l2.7-0.6l0.6-3.7   l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.6-3.1l3.9-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1c0.8,0,1.9,0.3,1.9,0.3l2.3-3.6l2.1-0.6l2.3,0.3   l1.6-3.6l2.9-2.6l0.5-2.1v-4l4.5,0.7l7.1-1.3l15.8-1.9l17.1-2.6l19.9-4l19.7-4.2l11.4-2.8L1006.1,398.5z M1010,431.5l2.6-2.5   l3.2-2.6l1.5-0.6l0.2-2l-0.6-6.1l-1.5-2.3l-0.6-1.9l0.7-0.2l2.7,5.5l0.4,4.4l-0.2,3.4l-3.4,1.5l-2.8,2.4l-1.1,1.2L1010,431.5z"
                        />
                      </g>

                      <g>
                        <title>Tennessee</title>
                        <path
                          v-on:click="clickState('TN')"
                          id="TN"
                          data-info="<div>State: Tennessee</div><div>Capital: Nashville</div>"
                          fill="#7C7C81"
                          d="M871.1,420.6l-51.9,5l-15.8,1.8l-4.6,0.5l-3.9,0v3.9l-8.4,0.5l-7,0.6l-11.1,0.1l-0.3,5.8l-2.1,6.3   l-1,3l-1.3,4.4l-0.3,2.6l-4,2.3l1.5,3.6l-1,4.4l-1,0.8l7.3-0.2l24.1-1.9l5.3-0.2l8.1-0.5l27.8-2.6l10.2-0.8l8.4-1l8.4-1.1l4.8-0.8   l-0.1-4.5l1.8-1.5l2.7-0.6l0.6-3.7l4.2-2.7l3.9-1.5l4.2-3.6l4.4-2.1l0.9-3.5l4.3-3.9l0.6-0.2c0,0,0,1.1,0.8,1.1s1.9,0.3,1.9,0.3   l2.3-3.6l2.1-0.6l2.3,0.3l1.6-3.6l2.1-2.2l0.6-1l0.2-3.9l-1.5-0.3l-2.4,1.9l-7.9,0.2l-12,1.9L871.1,420.6z"
                        />
                      </g>

                      <g>
                        <title>Rhode Island</title>
                        <path
                          v-on:click="clickState('RI')"
                          id="RI"
                          data-info="<div>State: Rhode Island</div><div>Capital: Providence</div>"
                          fill="#7C7C81"
                          d="M1048.1,279.8l-0.5-4.2l-0.8-4.4l-1.7-5.9l5.7-1.5l1.6,1.1l3.4,4.4l2.9,4.4l-2.9,1.5l-1.3-0.2   l-1.1,1.8l-2.4,1.9L1048.1,279.8z"
                        />
                      </g>

                      <g>
                        <title>Connecticut</title>
                        <path
                          v-on:click="clickState('CT')"
                          id="CT"
                          data-info="<div>State: Connecticut</div><div>Capital: Hartford</div>"
                          fill="#7C7C81"
                          d="M1047.2,280.1l-0.6-4.2l-0.8-4.4l-1.6-6l-4.2,0.9l-21.8,4.8l0.6,3.3l1.5,7.3v8.1l-1.1,2.3l1.8,2.1   l5-3.4l3.6-3.2l1.9-2.1l0.8,0.6l2.7-1.5l5.2-1.1L1047.2,280.1z"
                        />
                      </g>

                      <g>
                        <title>Massachusetts</title>
                        <path
                          v-on:click="clickState('MA')"
                          id="MA"
                          data-info="<div>State: Massachusetts</div><div>Capital: Boston</div>"
                          fill="#7C7C81"
                          d="M1074,273.9l2.2-0.7l0.5-1.7l1,0.1l1,2.3l-1.3,0.5l-3.9,0.1L1074,273.9z M1064.6,274.7l2.3-2.6h1.6   l1.8,1.5l-2.4,1l-2.2,1L1064.6,274.7z M1029.8,252.7l17.5-4.2l2.3-0.6l2.1-3.2l3.7-1.7l2.9,4.4l-2.4,5.2l-0.3,1.5l1.9,2.6l1.1-0.8   h1.8l2.3,2.6l3.9,6l3.6,0.5l2.3-1l1.8-1.8l-0.8-2.7l-2.1-1.6l-1.5,0.8l-1-1.3l0.5-0.5l2.1-0.2l1.8,0.8l1.9,2.4l1,2.9l0.3,2.4   l-4.2,1.5l-3.9,1.9l-3.9,4.5l-1.9,1.5v-1l2.4-1.5l0.5-1.8l-0.8-3.1l-2.9,1.5l-0.8,1.5l0.5,2.3l-2.1,1l-2.7-4.5l-3.4-4.4l-2.1-1.8   l-6.5,1.9l-5.1,1.1l-21.8,4.8l-0.4-4.9l0.6-10.6l5.2-0.9L1029.8,252.7z"
                        />
                      </g>

                      <g>
                        <title>Maine</title>
                        <path
                          v-on:click="clickState('ME')"
                          id="ME"
                          data-info="<div>State: Maine</div><div>Capital: Augusta</div>"
                          fill="#7C7C81"
                          d="M1097.2,177.3l1.9,2.1l2.3,3.7v1.9l-2.1,4.7l-1.9,0.6l-3.4,3.1l-4.8,5.5c0,0-0.6,0-1.3,0   c-0.6,0-1-2.1-1-2.1l-1.8,0.2l-1,1.5l-2.4,1.5l-1,1.5l1.6,1.5l-0.5,0.6l-0.5,2.7l-1.9-0.2v-1.6l-0.3-1.3l-1.5,0.3l-1.8-3.2   l-2.1,1.3l1.3,1.5l0.3,1.1l-0.8,1.3l0.3,3.1l0.2,1.6l-1.6,2.6l-2.9,0.5l-0.3,2.9l-5.3,3.1l-1.3,0.5l-1.6-1.5l-3.1,3.6l1,3.2   l-1.5,1.3l-0.2,4.4l-1.1,6.3l-2.5-1.2l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.2-13.6l1.4-0.1l1.5,0.4v-2.6l0.8-5.5l2.6-4.7l1.5-4   l-1.9-2.4v-6l0.8-1l0.8-2.7l-0.2-1.5l-0.2-4.8l1.8-4.8l2.9-8.9l2.1-4.2h1.3l1.3,0.2v1.1l1.3,2.3l2.7,0.6l0.8-0.8v-1l4-2.9l1.8-1.8   l1.5,0.2l6,2.4l1.9,1l9.1,29.9h6l0.8,1.9l0.2,4.8l2.9,2.3h0.8l0.2-0.5l-0.5-1.1L1097.2,177.3z M1076.3,207.5l1.5-1.5l1.4,1.1   l0.6,2.4l-1.7,0.9L1076.3,207.5z M1083,201.6l1.8,1.9c0,0,1.3,0.1,1.3-0.2s0.2-2,0.2-2l0.9-0.8l-0.8-1.8l-2,0.7L1083,201.6z"
                        />
                      </g>

                      <g>
                        <title>New Hampshire</title>
                        <path
                          v-on:click="clickState('NH')"
                          id="NH"
                          data-info="<div>State: New Hampshire</div><div>Capital: Concord</div>"
                          fill="#7C7C81"
                          d="M1054.8,242.4l0.9-1.1l1.1-3.3l-2.5-0.9l-0.5-3.1l-3.9-1.1l-0.3-2.7l-7.3-23.4l-4.6-14.5l-0.9,0   l-0.6,1.6l-0.6-0.5l-1-1l-1.5,1.9l0,5l0.3,5.7l1.9,2.7v4l-3.7,5.1l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5   l-0.5,1.8l1.5,0.9l16.4-4.7l2.3-0.6l1.5-2.6L1054.8,242.4z"
                        />
                      </g>

                      <g>
                        <title>Vermont</title>
                        <path
                          v-on:click="clickState('VT')"
                          id="VT"
                          data-info="<div>State: Vermont</div><div>Capital: Montpelier</div>"
                          fill="#7C7C81"
                          d="M1018.3,253.7l-0.8-5.7l-2.4-10l-0.6-0.3l-2.9-1.3l0.8-2.9l-0.8-2.1l-2.7-4.6l1-3.9l-0.8-5.2   l-2.4-6.5l-0.8-4.9l26.2-6.7l0.3,5.8l1.9,2.7v4l-3.7,4l-2.6,1.1v1.1l1.1,1.8v8.6l-0.8,9.2l-0.2,4.8l1,1.3l-0.2,4.5l-0.5,1.8   l0.7,1.6l-7,1.4L1018.3,253.7z"
                        />
                      </g>

                      <g>
                        <title>New York</title>
                        <path
                          v-on:click="clickState('NY')"
                          id="NY"
                          data-info="<div>State: New York</div><div>Capital: Albany</div>"
                          fill="#7C7C81"
                          d="M1002.6,289.4l-1.1-1l-2.6-0.2l-2.3-1.9l-1.6-6.1l-3.5,0.1l-2.4-2.7l-19.4,4.4l-43,8.7l-7.5,1.2   l-0.7-6.5l1.4-1.1l1.3-1.1l1-1.6l1.8-1.1l1.9-1.8l0.5-1.6l2.1-2.7l1.1-1l-0.2-1l-1.3-3.1l-1.8-0.2l-1.9-6.1l2.9-1.8l4.4-1.5l4-1.3   l3.2-0.5l6.3-0.2l1.9,1.3l1.6,0.2l2.1-1.3l2.6-1.1l5.2-0.5l2.1-1.8l1.8-3.2l1.6-1.9h2.1l1.9-1.1l0.2-2.3l-1.5-2.1l-0.3-1.5l1.1-2.1   v-1.5h-1.8l-1.8-0.8l-0.8-1.1l-0.2-2.6l5.8-5.5l0.6-0.8l1.5-2.9l2.9-4.5l2.7-3.7l2.1-2.4l2.4-1.8l3.1-1.2l5.5-1.3l3.2,0.2l4.5-1.5   l7.6-2.1l0.5,5l2.4,6.5l0.8,5.2l-1,3.9l2.6,4.5l0.8,2.1l-0.8,2.9l2.9,1.3l0.6,0.3l3.1,11l-0.5,5.1l-0.5,10.8l0.8,5.5l0.8,3.6   l1.5,7.3v8.1l-1.1,2.3l1.8,2l0.8,1.7l-1.9,1.8l0.3,1.3l1.3-0.3l1.5-1.3l2.3-2.6l1.1-0.6l1.6,0.6l2.3,0.2l7.9-3.9l2.9-2.7l1.3-1.5   l4.2,1.6l-3.4,3.6l-3.9,2.9l-7.1,5.3l-2.6,1l-5.8,1.9l-4,1.1l-1.2-0.5l-0.2-3.7l0.5-2.7l-0.2-2.1l-2.8-1.7l-4.5-1l-3.9-1.1   L1002.6,289.4z"
                        />
                      </g>

                      <g>
                        <title>New Jersey</title>
                        <path
                          v-on:click="clickState('NJ')"
                          id="NJ"
                          data-info="<div>State: New Jersey</div><div>Capital: Trenton</div>"
                          fill="#7C7C81"
                          d="M1002.2,290.3l-2.1,2.4v3.1l-1.9,3.1l-0.2,1.6l1.3,1.3l-0.2,2.4l-2.3,1.1l0.8,2.7l0.2,1.1l2.7,0.3   l1,2.6l3.6,2.4l2.4,1.6v0.8l-3.2,3.1l-1.6,2.3l-1.5,2.7l-2.3,1.3l-1.2,0.7l-0.2,1.2l-0.6,2.6l1.1,2.2l3.2,2.9l4.8,2.3l4,0.6   l0.2,1.5l-0.8,1l0.3,2.7h0.8l2.1-2.4l0.8-4.8l2.7-4l3.1-6.5l1.1-5.5l-0.6-1.1l-0.2-9.4l-1.6-3.4l-1.1,0.8l-2.7,0.3l-0.5-0.5l1.1-1   l2.1-1.9l0.1-1.1l-0.4-3.4l0.5-2.7l-0.2-2.1l-2.6-1.1l-4.5-1l-3.9-1.1L1002.2,290.3z"
                        />
                      </g>

                      <g>
                        <title>Pennsylvania</title>
                        <path
                          v-on:click="clickState('PA')"
                          id="PA"
                          data-info="<div>State: Pennsylvania</div><div>Capital: Harrisburg</div>"
                          fill="#7C7C81"
                          d="M996.2,326.5l1.1-0.6l2.3-0.6l1.5-2.7l1.6-2.3l3.2-3.1v-0.8l-2.4-1.6l-3.6-2.4l-1-2.6l-2.7-0.3   l-0.2-1.1l-0.8-2.7l2.3-1.1l0.2-2.4l-1.3-1.3l0.2-1.6l1.9-3.1v-3.1l2.3-2.4l0.2-1.1l-2.6-0.2l-2.3-1.9l-2.4-5.3l-3-0.9l-2.3-2.1   l-18.6,4l-43,8.7l-8.9,1.5l-0.5-7.1l-5.5,5.6l-1.3,0.5l-4.2,3l2.9,19.1l2.5,9.7l3.6,19.3l3.3-0.6l11.9-1.5l37.9-7.7l14.9-2.8   l8.3-1.6l0.3-0.2l2.1-1.6L996.2,326.5z"
                        />
                      </g>

                      <g>
                        <title>Delaware</title>
                        <path
                          v-on:click="clickState('DE')"
                          id="DE"
                          data-info="<div>State: Delaware</div><div>Capital: Dover</div>"
                          fill="#7C7C81"
                          d="M996.4,330.4l0.6-2.1l0-1.2l-1.3-0.1l-2.1,1.6l-1.5,1.5l1.5,4.2l2.3,5.7l2.1,9.7l1.6,6.3l5-0.2   l6.1-1.2l-2.3-7.4l-1,0.5l-3.6-2.4l-1.8-4.7l-1.9-3.6l-2.3-1l-2.1-3.6L996.4,330.4z"
                        />
                      </g>

                      <g>
                        <title>Maryland</title>
                        <path
                          v-on:click="clickState('MD')"
                          id="MD"
                          data-info="<div>State: Maryland</div><div>Capital: Annapolis</div>"
                          fill="#7C7C81"
                          d="M1011,355.3l-6.1,1.3l-5.8,0.2l-1.8-7.1l-2.1-9.7l-2.3-5.7l-1.3-4.4l-7.5,1.6l-14.9,2.8l-37.5,7.6   l1.1,5l1,5.7l0.3-0.3l2.1-2.4l2.3-2.6l2.4-0.6l1.5-1.5l1.8-2.6l1.3,0.6l2.9-0.3l2.6-2.1l2-1.5l1.8-0.5l1.6,1.1l2.9,1.5l1.9,1.8   l1.2,1.5l4.1,1.7v2.9l5.5,1.3l1.1,0.5l1.4-2l2.9,2l-1.3,2.5l-0.8,4l-1.8,2.6v2.1l0.6,1.8l5.1,1.4l4.3-0.1l3.1,1l2.1,0.3l1-2.1   l-1.5-2.1v-1.8l-2.4-2.1l-2.1-5.5l1.3-5.3l-0.2-2.1l-1.3-1.3c0,0,1.5-1.6,1.5-2.3c0-0.6,0.5-2.1,0.5-2.1l1.9-1.3l1.9-1.6l0.5,1   l-1.5,1.6l-1.3,3.7l0.3,1.1l1.8,0.3l0.5,5.5l-2.1,1l0.3,3.6l0.5-0.2l1.1-1.9l1.6,1.8l-1.6,1.3l-0.3,3.4l2.6,3.4l3.9,0.5l1.6-0.8   l3.2,4.2l1.4,0.5l6.7-2.8l2-4L1011,355.3z M994.3,364.3l1.1,2.5l0.2,1.8l1.1,1.9c0,0,0.9-0.9,0.9-1.2c0-0.3-0.7-3.1-0.7-3.1   l-0.7-2.3L994.3,364.3z"
                        />
                      </g>

                      <g>
                        <title>West Virginia</title>
                        <path
                          v-on:click="clickState('WV')"
                          id="WV"
                          data-info="<div>State: West Virginia</div><div>Capital: Charleston</div>"
                          fill="#7C7C81"
                          d="M930.6,342l1.1,4.9l1.1,6.9l3.6-2.7l2.3-3.1l2.5-0.6l1.5-1.5l1.8-2.6l1.2,0.6l2.9-0.3l2.6-2.1   l2-1.5l1.8-0.5l1.3,1l2.2,1.1l1.9,1.8l1.4,1.3l-0.1,4.7l-5.7-3.1l-4.5-1.8l-0.2,5.3l-0.5,2.1l-1.6,2.7l-0.6,1.6l-3.1,2.4l-0.5,2.3   l-3.4,0.3l-0.3,3.1l-1.1,5.5h-2.6l-1.3-0.8l-1.6-2.7l-1.8,0.2l-0.3,4.4l-2.1,6.6l-5,10.8l0.8,1.3l-0.2,2.7l-2.1,1.9l-1.5-0.3   l-3.2,2.4l-2.6-1l-1.8,4.7c0,0-3.7,0.8-4.4,1c-0.6,0.2-2.4-1.3-2.4-1.3l-2.4,2.3l-2.6,0.6l-2.9-0.8l-1.3-1.3l-2.2-3l-3.1-2   l-2.6-2.7l-2.9-3.7l-0.6-2.3l-2.6-1.5l-0.8-1.6l-0.2-5.3l2.2-0.1l1.9-0.8l0.2-2.7l1.6-1.5l0.2-5l1-3.9l1.3-0.6l1.3,1.1l0.5,1.8   l1.8-1l0.5-1.6l-1.1-1.8v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9l0.3-5.7l0.5-5v-4.7l-1.1-3.1l1-1.5l1.3-1.3   l3.5,19.8l4.6-0.8L930.6,342z"
                        />
                      </g>

                      <g>
                        <title>Kentucky</title>
                        <path
                          v-on:click="clickState('KY')"
                          id="KY"
                          data-info="<div>State: Kentucky</div><div>Capital: Frankfort</div>"
                          fill="#7C7C81"
                          d="M895.8,397.8l-2.3,2.7l-4.2,3.6L885,410l-1.8,1.8v2.1l-3.9,2.1l-5.7,3.4l-3.5,0.4l-51.9,4.9   l-15.8,1.8l-4.6,0.5l-3.9,0l-0.2,4.2l-8.2,0.1l-7,0.6l-10.4,0.2l1.9-0.2l2.2-1.8l2.1-1.1l0.2-3.2l0.9-1.8l-1.6-2.5l0.8-1.9l2.3-1.8   l2.1-0.6l2.7,1.3l3.6,1.3l1.1-0.3l0.2-2.3l-1.3-2.4l0.3-2.3l1.9-1.5l2.6-0.6l1.6-0.6l-0.8-1.8l-0.6-1.9l1.1-0.8l1.1-3.3l3-1.7   l5.8-1l3.6-0.5l1.5,1.9l1.8,0.8l1.8-3.2l2.9-1.5l1.9,1.6l0.8,1.1l2.1-0.5l-0.2-3.4l2.9-1.6l1.1-0.8l1.1,1.6h4.7l0.8-2.1l-0.3-2.3   l2.9-3.6l4.7-3.9l0.5-4.5l2.7-0.3l3.9-1.8l2.7-1.9l-0.3-1.9l-1.5-1.5l0.6-2.2l4.1-0.2l2.4-0.8l2.9,1.6l1.6,4.4l5.8,0.3l1.8,1.8   l2.1,0.2l2.4-1.5l3.1,0.5l1.3,1.5l2.7-2.6l1.8-1.3h1.6l0.6,2.7l1.8,1l2.4,2.2l0.2,5.5l0.8,1.6l2.6,1.5l0.6,2.3l2.9,3.7l2.6,2.7   L895.8,397.8z"
                        />
                      </g>

                      <g>
                        <title>Ohio</title>
                        <path
                          v-on:click="clickState('OH')"
                          id="OH"
                          data-info="<div>State: Ohio</div><div>Capital: Columbus</div>"
                          fill="#7C7C81"
                          d="M905.4,295l-6.1,4.1l-3.9,2.3l-3.4,3.7l-4,3.9l-3.2,0.8l-2.9,0.5l-5.5,2.6l-2.1,0.2l-3.4-3.1   l-5.2,0.6l-2.6-1.5l-2.4-1.4l-4.9,0.7l-10.2,1.6l-7.8,1.2l1.3,14.6l1.8,13.7l2.6,23.4l0.6,4.8l4.1-0.1l2.4-0.8l3.4,1.5l2.1,4.4   l5.1,0l1.9,2.1l1.8-0.1l2.5-1.3l2.5,0.4l2,1.5l1.7-2.1l2.3-1.3l2.1-0.7l0.6,2.7l1.8,1l3.5,2.3l2.2-0.1l1.1-1.1l-0.1-1.4l1.6-1.5   l0.2-5l1-3.9l1.5-1.4l1.5,0.9l0.8,1.2l1.2-0.2l-0.4-2.4l-0.6-0.6v-2.4l1-1.3l2.3-3.4l1.3-1.5l2.1,0.5l2.3-1.6l3.1-3.4l2.3-3.9   l0.2-5.4l0.5-5v-4.7l-1.1-3.1l1-1.5l0.9-1l-1.4-9.8L905.4,295z"
                        />
                      </g>

                      <g>
                        <title>Michigan</title>
                        <path
                          v-on:click="clickState('MI')"
                          id="MI"
                          data-info="<div>State: Michigan</div><div>Capital: Lansing</div>"
                          fill="#7C7C81"
                          d="M755.6,182.1l1.8-2.1l2.2-0.8l5.4-3.9l2.3-0.6l0.5,0.5l-5.1,5.1l-3.3,1.9l-2.1,0.9L755.6,182.1z    M841.8,214.2l0.6,2.5l3.2,0.2l1.3-1.2c0,0-0.1-1.5-0.4-1.6c-0.3-0.2-1.6-1.9-1.6-1.9l-2.2,0.2l-1.6,0.2l-0.3,1.1L841.8,214.2z    M871.9,277.2l-3.2-8.2l-2.3-9.1l-2.4-3.2l-2.6-1.8l-1.6,1.1l-3.9,1.8l-1.9,5l-2.7,3.7l-1.1,0.6l-1.5-0.6c0,0-2.6-1.5-2.4-2.1   c0.2-0.6,0.5-5,0.5-5l3.4-1.3l0.8-3.4l0.6-2.6l2.4-1.6l-0.3-10l-1.6-2.3l-1.3-0.8l-0.8-2.1l0.8-0.8l1.6,0.3l0.2-1.6L850,231   l-1.3-2.6h-2.6l-4.5-1.5l-5.5-3.4h-2.7l-0.6,0.6l-1-0.5l-3.1-2.3l-2.9,1.8l-2.9,2.3l0.3,3.6l1,0.3l2.1,0.5l0.5,0.8l-2.6,0.8   l-2.6,0.3l-1.5,1.8l-0.3,2.1l0.3,1.6l0.3,5.5l-3.6,2.1l-0.6-0.2v-4.2l1.3-2.4l0.6-2.4l-0.8-0.8l-1.9,0.8l-1,4.2l-2.7,1.1l-1.8,1.9   l-0.2,1l0.6,0.8l-0.6,2.6l-2.3,0.5v1.1l0.8,2.4l-1.1,6.1l-1.6,4l0.6,4.7l0.5,1.1l-0.8,2.4l-0.3,0.8l-0.3,2.7l3.6,6l2.9,6.5l1.5,4.8   l-0.8,4.7l-1,6l-2.4,5.2l-0.3,2.7l-3.3,3.1l4.4-0.2l21.4-2.3l7.3-1l0.1,1.7l6.9-1.2l10.3-1.5l3.9-0.5l0.1-0.6l0.2-1.5l2.1-3.7   l2-1.7l-0.2-5.1l1.6-1.6l1.1-0.3l0.2-3.6l1.5-3l1.1,0.6l0.2,0.6l0.8,0.2l1.9-1L871.9,277.2z M741.5,211.2l0.7-0.6l2.7-0.8l3.6-2.3   v-1l0.6-0.6l6-1l2.4-1.9l4.4-2.1l0.2-1.3l1.9-2.9l1.8-0.8l1.3-1.8l2.3-2.3l4.4-2.4l4.7-0.5l1.1,1.1l-0.3,1l-3.7,1l-1.5,3.1   l-2.3,0.8l-0.5,2.4l-2.4,3.2l-0.3,2.6l0.8,0.5l1-1.1l3.6-2.9l1.3,1.3h2.3l3.2,1l1.5,1.1l1.5,3.1l2.7,2.7l3.9-0.2l1.5-1l1.6,1.3   l1.6,0.5l1.3-0.8h1.1l1.6-1l4-3.6l3.4-1.1l6.6-0.3l4.5-1.9l2.6-1.3l1.5,0.2v5.7l0.5,0.3l2.9,0.8l1.9-0.5l6.1-1.6l1.1-1.1l1.5,0.5v7   l3.2,3.1l1.3,0.6l1.3,1l-1.3,0.3l-0.8-0.3l-3.7-0.5l-2.1,0.6l-2.3-0.2l-3.2,1.5h-1.8l-5.8-1.3l-5.2,0.2l-1.9,2.6l-7,0.6l-2.4,0.8   l-1.1,3.1l-1.3,1.1l-0.5-0.2l-1.5-1.6l-4.5,2.4h-0.6l-1.1-1.6l-0.8,0.2l-1.9,4.4l-1,4l-3.2,7l-1.2-1l-1.4-1l-1.9-10.3l-3.5-1.4   l-2.1-2.3l-12.1-2.7l-2.9-1l-8.2-2.2l-7.9-1.1L741.5,211.2z"
                        />
                      </g>

                      <g>
                        <title>Wyoming</title>
                        <path
                          v-on:click="clickState('WY')"
                          id="WY"
                          data-info="<div>State: Wyoming</div><div>Capital: Cheyenne</div>"
                          fill="#7C7C81"
                          d="M528.3,243.8l-10.5-0.8l-32.1-3.3l-16.2-2.1l-28.3-4.1l-19.9-3l-1.4,11.2l-3.8,24.3l-5.3,30.4   l-1.5,10.5l-1.7,11.9l6.5,0.9l25.9,2.5l20.6,2.3l36.8,4.1l23.8,2.9l4.5-44.2l1.4-25.4L528.3,243.8z"
                        />
                      </g>

                      <g>
                        <title>Montana</title>
                        <path
                          v-on:click="clickState('MT')"
                          id="MT"
                          data-info="<div>State: Montana</div><div>Capital: Helena</div>"
                          fill="#7C7C81"
                          d="M530.7,222.3l0.6-11.2l2.3-24.8c0.5-5,1.1-8.5,1.4-15.4l0.9-14.6l-30.7-2.8L476,150l-29.3-4   l-32.3-5.3l-18.4-3.4l-32.7-6.9l-4.5,21.3l3.4,7.5l-1.4,4.6l1.8,4.6l3.2,1.4l4.6,10.8l2.7,3.2l0.5,1.1l3.4,1.1l0.5,2.1l-7.1,17.6   v2.5l2.5,3.2h0.9l4.8-3l0.7-1.1l1.6,0.7l-0.2,5.3l2.7,12.6l3,2.5l0.9,0.7l1.8,2.3l-0.5,3.4l0.7,3.4l1.1,0.9l2.3-2.3h2.7l3.2,1.6   l2.5-0.9h4.1l3.7,1.6l2.7-0.5l0.5-3l3-0.7l1.4,1.4l0.5,3.2l1.8,1.4l1.5-11.6l20.7,3l28.2,4l16.6,1.9l31.4,3.5l11,1.5l1.1-15.4   L530.7,222.3z"
                        />
                      </g>

                      <g>
                        <title>Idaho</title>
                        <path
                          v-on:click="clickState('ID')"
                          id="ID"
                          data-info="<div>State: Idaho</div><div>Capital: Boise</div>"
                          fill="#7C7C81"
                          d="M336.1,281c-22.6-4.3-14.1-2.8-21.1-4.4l4.4-17.5l4.3-17.7l1.4-4.2l2.5-5.9l-1.3-2.3l-2.5,0.1   l-0.8-1l0.5-1.1l0.3-3.1l4.5-5.5l1.8-0.5l1.1-1.1l0.6-3.2l0.9-0.7l3.9-5.8l3.9-4.3l0.2-3.8l-3.4-2.6l-1.3-4.4l0.4-9.7l3.7-16.5   l4.5-20.8l3.8-13.5l0.8-3.8l13,2.5l-4.2,21.5l2.9,7.7l-1.1,4.6l2,4.6l3.2,1.7l4.5,9.8l2.7,3.8l0.6,1.1l3.4,1.1l0.5,2.5l-6.9,16.8   l0.3,3.3l2.7,2.9l1.9,0.5l4.8-3.6l0.4-0.5l0.2,0.8l0.3,4.1l2.6,12.9l3.5,2.7l0.4,0.8l2.1,2.4l-0.8,2.8l0.7,3.8l1.9,0.9l2.1-1.6   l2.6-0.5l3.4,1.6l2.5-0.6l3.8-0.2l4,1.6l2.7-0.3l0.9-2.3l2.5-1.6l0.7,1.7l0.6,2.2l2.3,2.5l-3.8,24l-5.1,29l-4.2-0.3l-8.2-1.5   l-9.8-1.8l-12.2-2.4l-12.5-2.5l-8.5-1.8l-9.3-1.7L336.1,281z"
                        />
                      </g>

                      <g>
                        <title>Washington</title>
                        <path
                          v-on:click="clickState('WA')"
                          id="WA"
                          data-info="<div>State: Washington</div><div>Capital: Olympia</div>"
                          fill="#7C7C81"
                          d="M267.6,106.4l4.4,1.5l9.7,2.7l8.6,1.9l20,5.7l23,5.7l15.2,3.4l-1,3.9l-4.1,13.8l-4.5,20.8   l-3.2,16.1l-0.4,9.4l-13.2-3.9l-15.6-3.4l-13.7,0.6l-1.6-1.5l-5.3,1.9l-4-0.3l-2.7-1.8l-1.6,0.5l-4.2-0.2l-1.9-1.4l-4.8-1.7   l-1.4-0.2l-5-1.3l-1.8,1.5l-5.7-0.3l-4.8-3.8l0.2-0.8l0.1-7.9l-2.1-3.9l-4.1-0.7l-0.4-2.4l-2.5-0.6l-2.9-0.5l-1.8,1l-2.3-2.9   l0.3-2.9l2.7-0.3l1.6-4l-2.6-1.1l0.2-3.7l4.4-0.6l-2.7-2.7l-1.5-7.1l0.6-2.9v-7.9l-1.8-3.2l2.3-9.4l2.1,0.5l2.4,2.9l2.7,2.6   l3.2,1.9l4.5,2.1l3.1,0.6l2.9,1.5l3.4,1l2.3-0.2v-2.4l1.3-1.1l2.1-1.3l0.3,1.1l0.3,1.8l-2.3,0.5l-0.3,2.1l1.8,1.5l1.1,2.4l0.6,1.9   l1.5-0.2l0.2-1.3l-1-1.3l-0.5-3.2l0.8-1.8l-0.6-1.5V119l1.8-3.6l-1.1-2.6l-2.4-4.8l0.3-0.8L267.6,106.4z M258.1,112.3l2-0.2   l0.5,1.4l1.5-1.6h2.3l0.8,1.5l-1.5,1.7l0.6,0.8l-0.7,2l-1.4,0.4c0,0-0.9,0.1-0.9-0.2s1.5-2.6,1.5-2.6l-1.7-0.6l-0.3,1.5l-0.7,0.6   l-1.5-2.3L258.1,112.3z"
                        />
                      </g>

                      <g>
                        <title>Texas</title>
                        <path
                          v-on:click="clickState('TX')"
                          id="TX"
                          data-info="<div>State: Texas</div><div>Capital: Austin</div>"
                          fill="#7C7C81"
                          d="M531.1,433.4l22.7,1.1l31.1,1.1l-2.3,23.5l-0.3,18.2l0.1,2.1l4.3,3.8l1.7,0.8l1.8,0.3l0.7-1.3   l0.9,0.9l1.7,0.5l1.6-0.7l1.1,0.4l-0.3,3.4l4.3,1l2.7,0.8l4,0.5l2.2,1.8l3.2-1.6l2.8,0.4l2,2.8l1.1,0.3l-0.2,2l3.1,1.2l2.8-1.8   l1.5,0.4l2.4,0.2l0.4,1.9l4.6,2l2.7-0.2l2-4.1h0.3l1.1,1.9l4.4,1l3.3,1.2l3.3,0.8l2.1-0.8l0.8-2.5h3.7l1.9,0.8l3.1-1.6h0.7l0.4,1.1   h4.3l2.4-1.3l1.7,0.3l1.4,1.9l2.9,1.7l3.5,1.1l2.7,1.4l2.4,1.6l3.3-0.9l1.9,1l0.5,10.1l0.3,9.7l0.7,9.5l0.5,4l2.7,4.6l1.1,4.1   l3.9,6.3l0.5,2.9l0.5,1l-0.7,7.5l-2.7,4.4l1,2.9l-0.4,2.5l-0.8,7.3l-1.4,2.7l0.6,4.4l-5.7,1.6l-9.9,4.5l-1,1.9l-2.6,1.9l-2.1,1.5   l-1.3,0.8l-5.7,5.3l-2.7,2.1l-5.3,3.2l-5.7,2.4l-6.3,3.4l-1.8,1.5l-5.8,3.6l-3.4,0.6l-3.9,5.5l-4,0.3l-1,1.9l2.3,1.9l-1.5,5.5   l-1.3,4.5l-1.1,3.9l-0.8,4.5l0.8,2.4l1.8,7l1,6.1l1.8,2.7l-1,1.5l-3.1,1.9l-5.7-3.9l-5.5-1.1l-1.3,0.5l-3.2-0.6l-4.2-3.1l-5.2-1.1   l-7.6-3.4l-2.1-3.9l-1.3-6.5l-3.2-1.9l-0.6-2.3l0.6-0.6l0.3-3.4l-1.3-0.6l-0.6-1l1.3-4.4l-1.6-2.3l-3.2-1.3l-3.4-4.4l-3.6-6.6   l-4.2-2.6l0.2-1.9l-5.3-12.3l-0.8-4.2l-1.8-1.9l-0.2-1.5l-6-5.3l-2.6-3.1v-1.1l-2.6-2.1l-6.8-1.1l-7.4-0.6l-3.1-2.3l-4.5,1.8   l-3.6,1.5l-2.3,3.2l-1,3.7l-4.4,6.1l-2.4,2.4l-2.6-1l-1.8-1.1l-1.9-0.6l-3.9-2.3v-0.6l-1.8-1.9l-5.2-2.1l-7.4-7.8l-2.3-4.7v-8.1   l-3.2-6.5l-0.5-2.7l-1.6-1l-1.1-2.1l-5-2.1l-1.3-1.6l-7.1-7.9l-1.3-3.2l-4.7-2.3l-1.5-4.4l-2.6-2.9l-1.9-0.5l-0.6-4.7l8,0.7l29,2.7   l29,1.6l2.3-23.8l3.9-55.6l1.6-18.7l1.4,0 M631.2,667.3l-0.6-7.1l-2.7-7.2l-0.6-7l1.5-8.2l3.3-6.9l3.5-5.4l3.2-3.6l0.6,0.2   l-4.8,6.6l-4.4,6.5l-2,6.6l-0.3,5.2l0.9,6.1l2.6,7.2l0.5,5.2l0.2,1.5L631.2,667.3z"
                        />
                      </g>

                      <g>
                        <title>California</title>
                        <path
                          v-on:click="clickState('CA')"
                          id="CA"
                          data-info="<div>State: California</div><div>Capital: Sacramento</div>"
                          fill="#7C7C81"
                          d="M310.7,486.8l3.8-0.5l1.5-2l0.7-1.9l-3.2-0.1l-1.1-1.8l0.8-1.7l0-6.2l2.2-1.3l2.7-2.6l0.4-4.9   l1.6-3.5l1.9-2.1l3.3-1.7l1.3-0.7l0.8-1.5l-0.9-0.9l-1-1.5l-0.9-5.3l-2.9-5.2l0.1-2.8l-2.2-3.2l-15-23.2l-19.4-28.7l-22.4-33   l-12.7-19.5l1.8-7.2l6.8-25.9l8.1-31.4l-12.4-3.3l-13.5-3.4l-12.6-4.1l-7.5-2.1l-11.4-3l-7.1-2.4l-1.6,4.7l-0.2,7.4l-5.2,11.8   l-3.1,2.6l-0.3,1.1l-1.8,0.8l-1.5,4.2l-0.8,3.2l2.7,4.2l1.6,4.2l1.1,3.6l-0.3,6.5l-1.8,3.1l-0.6,5.8l-1,3.7l1.8,3.9l2.7,4.5   l2.3,4.8l1.3,4l-0.3,3.2l-0.3,0.5v2.1l5.7,6.3l-0.5,2.4l-0.6,2.3l-0.6,1.9l0.2,8.2l2.1,3.7l1.9,2.6l2.7,0.5l1,2.7l-1.1,3.6   l-2.1,1.6h-1.1l-0.8,3.9l0.5,2.9l3.2,4.4l1.6,5.3l1.5,4.7l1.3,3.1l3.4,5.8l1.5,2.6l0.5,2.9l1.6,1v2.4l-0.8,1.9l-1.8,7.1l-0.5,1.9   l2.4,2.7l4.2,0.5l4.5,1.8l3.9,2.1h2.9l2.9,3.1l2.6,4.8l1.1,2.3l3.9,2.1l4.8,0.8l1.5,2.1l0.6,3.2l-1.5,0.6l0.3,1l3.2,0.8l2.7,0.2   l2.9,4.7l3.9,4.2l0.8,2.3l2.6,4.2l0.3,3.2v9.4l0.5,1.8l10,1.5l19.7,2.7L310.7,486.8z M222.8,437l1.3,1.5l-0.2,1.3l-3.2-0.1   l-0.6-1.2l-0.6-1.5L222.8,437z M224.7,437l1.2-0.6l3.6,2.1l3.1,1.2l-0.9,0.6l-4.5-0.2l-1.6-1.6L224.7,437z M245.4,456.8l1.8,2.3   l0.8,1l1.5,0.6l0.6-1.5l-1-1.8l-2.7-2l-1.1,0.2V456.8z M244,465.5l1.8,3.2l1.2,1.9l-1.5,0.2l-1.3-1.2c0,0-0.7-1.5-0.7-1.9   s0-2.2,0-2.2L244,465.5z"
                        />
                      </g>

                      <g>
                        <title>Arizona</title>
                        <path
                          v-on:click="clickState('AZ')"
                          id="AZ"
                          data-info="<div>State: Arizona</div><div>Capital: Phoenix</div>"
                          fill="#7C7C81"
                          d="M311.7,487.5l-2.6,2.2l-0.3,1.5l0.5,1l18.9,10.7l12.1,7.6l14.7,8.6l16.8,10l12.3,2.4l25.1,2.7   l2.5-12.5l3.8-27.2l7-52.9l4.3-31l-24.6-3.7l-27.2-4.6l-33.4-6.3l-2.9,18.1l-0.5,0.5l-1.7,2.6l-2.5-0.1l-1.3-2.7l-2.7-0.3l-0.9-1.1   h-0.9l-0.9,0.6l-1.9,1l-0.1,7l-0.2,1.7l-0.6,12.6l-1.5,2.2l-0.6,3.3l2.7,4.9l1.3,5.8l0.8,1l1,0.6l-0.1,2.3l-1.6,1.4l-3.4,1.7   l-1.9,1.9l-1.5,3.7l-0.6,4.9l-2.9,2.7l-2.1,0.7l-0.1,5.8l-0.5,1.7l0.5,0.8l3.7,0.6l-0.6,2.7l-1.5,2.2L311.7,487.5z"
                        />
                      </g>

                      <g>
                        <title>Nevada</title>
                        <path
                          v-on:click="clickState('NV')"
                          id="NV"
                          data-info="<div>State: Nevada</div><div>Capital: Carson City</div>"
                          fill="#7C7C81"
                          d="M314.7,277.6l21,4.5l9.7,1.9l9.3,1.8l6.6,1.6l-0.6,5.9l-3.5,17.3l-4.1,20l-1.9,9.7l-2.2,13.3   l-3.2,16.4l-3.5,15.7l-2,10.2l-2.5,16.8l-0.5,1.1l-1.1,2.5l-1.9-0.1l-1.1-2.7l-2.7-0.5l-1.4-1l-2,0.3l-0.9,0.7l-1.3,1.3l-0.4,7   l-0.5,1.7l-0.4,12.1l-1.3,1.7l-1.9-2.3l-14.5-22.7l-19.4-29L263.6,349l-12.4-18.6l1.6-6.6l7-25.9l7.9-31.3l33.6,8.1l13.7,3"
                        />
                      </g>

                      <g>
                        <title>Utah</title>
                        <path
                          v-on:click="clickState('UT')"
                          id="UT"
                          data-info="<div>State: Utah</div><div>Capital: Salt Lake City</div>"
                          fill="#7C7C81"
                          d="M427,409.3l-24.6-3.5l-26.6-4.9l-33.8-6l1.6-9.2l3.2-15.2L350,354l2.2-13.6l1.9-8.9l3.8-20.5   l3.5-17.5l1.1-5.6l12.7,2.3l12,2.1l10.3,1.8l8.3,1.4l3.7,0.5l-1.5,10.6l-2.3,13.2l7.8,0.9l16.4,1.8l8.2,0.9l-2.1,22l-3.2,22.6   l-3.8,27.8l-1.7,11.1L427,409.3z"
                        />
                      </g>

                      <g>
                        <title>Colorado</title>
                        <path
                          v-on:click="clickState('CO')"
                          id="CO"
                          data-info="<div>State: Colorado</div><div>Capital: Denver</div>"
                          fill="#7C7C81"
                          d="M552.6,356.8l1.4-21.3l-32.1-3.1l-24.5-2.7l-37.3-4.1l-20.7-2.5l-2.6,22.2l-3.2,22.4l-3.8,28   l-1.5,11.1l-0.3,2.8l33.9,3.8l37.7,4.3l32,3.2l16.6,0.8"
                        />
                      </g>

                      <g>
                        <title>New Mexico</title>
                        <path
                          v-on:click="clickState('NM')"
                          id="NM"
                          data-info="<div>State: New Mexico</div><div>Capital: Santa Fe</div>"
                          fill="#7C7C81"
                          d="M456.7,531l-0.7-6.1l8.6,0.5l29.5,3.1l28.4,1.4l2-22.3l3.7-55.9l1.1-19.4l2,0.3l0-11.1l-32.2-2.4   l-36.9-4.4l-34.5-4.1l-4.2,30.8l-7,53.2l-3.8,26.9l-2,13.3l15.5,2l1.3-10l16.7,2.6L456.7,531z"
                        />
                      </g>

                      <g>
                        <title>Oregon</title>
                        <path
                          v-on:click="clickState('OR')"
                          id="OR"
                          data-info="<div>State: Oregon</div><div>Capital: Salem</div>"
                          fill="#7C7C81"
                          d="M314.3,276.7l4.3-17.9l4.7-17.9l1.1-4.2l2.4-5.6l-0.6-1.2l-2.5,0l-1.3-1.7l0.5-1.5l0.5-3.2l4.5-5.5   l1.8-1.1l1.1-1.1l1.5-3.6l4-5.7l3.6-3.9l0.2-3.5l-3.3-2.5l-1.2-4.5l-13.2-3.7l-15.1-3.5l-15.4,0.1l-0.5-1.4l-5.5,2.1l-4.5-0.6   l-2.4-1.6l-1.3,0.7L273,184l-1.7-1.4l-5.3-2.1l-0.8,0.1l-4.3-1.5l-1.9,1.8l-6.2-0.3l-5.9-4.1l0.7-0.8l0.2-7.8l-2.3-3.9l-4.1-0.6   l-0.7-2.5l-2.4-0.5l-5.8,2.1l-2.3,6.5l-3.2,10l-3.2,6.5l-5,14.1l-6.5,13.6l-8.1,12.6l-1.9,2.9l-0.8,8.6l-1.3,6l2.7,3.5l6.7,2.3   l11.6,3.3l7.9,2.5l12.4,3.6l13.3,3.6l13.2,3.6"
                        />
                      </g>

                      <g>
                        <title>North Dakota</title>
                        <path
                          v-on:click="clickState('ND')"
                          id="ND"
                          data-info="<div>State: North Dakota</div><div>Capital: Bismarck</div>"
                          fill="#7C7C81"
                          d="M645.3,227.7l-0.4-7.5l-2-7.3l-1.8-13.6l-0.5-9.8l-2-3.1l-1.6-5.4v-10.3l0.7-3.9l-2.1-5.5   l-28.4-0.6l-18.6-0.6l-26.5-1.3l-24.9-1.9l-1.3,14.2l-1.4,15.1l-2.3,24.9l-0.5,11l56.8,3.8L645.3,227.7z"
                        />
                      </g>

                      <g>
                        <title>South Dakota</title>
                        <path
                          v-on:click="clickState('SD')"
                          id="SD"
                          data-info="<div>State: South Dakota</div><div>Capital: Pierre</div>"
                          fill="#7C7C81"
                          d="M646.8,303.2l-1-1.1l-1.5-3.6l1.8-3.7l1.1-5.6l-2.6-2.1l-0.3-2.7l0.6-3l2.2-0.8l0.3-5.7l-0.1-30.1   l-0.6-3l-4.1-3.6l-1-2v-1.9l1.9-1.3l1.5-1.9l0.2-2.7l-57.4-1.6l-56.2-3.9l-0.8,5.3l-1.6,15.9l-1.3,17.9l-1.6,24.6l16,1l19.6,1.1   l18,1.3l23.8,1.3l10.7-0.8l2.9,2.3l4.3,3l1,0.8l3.5-0.9l4-0.3l2.7-0.1l3.1,1.2l4.5,1.4l3.1,1.8l0.6,1.9l0.9,1.9l0.7-0.5   L646.8,303.2z"
                        />
                      </g>

                      <g>
                        <title>Nebraska</title>
                        <path
                          v-on:click="clickState('NE')"
                          id="NE"
                          data-info="<div>State: Nebraska</div><div>Capital: Lincoln</div>"
                          fill="#7C7C81"
                          d="M658.2,347l1.4,2.7l0.1,2.1l2.4,3.7l2.7,3.2h-5l-43.5-0.9l-40.8-0.9l-21.2-1l1.1-21.3l-33.4-2.7   l4.3-44l15.5,1L562,290l17.8,1.1l23.8,1.1l10.7-0.5l2.1,2.3l4.8,3l1.1,0.9l4.3-1.4l3.9-0.5l2.7-0.2l1.8,1.4l5,1.6l3,1.6l0.5,1.6   l0.9,2.1h1.8l0.8,0l1,5.2l2.7,8l1.2,4.6l2.1,3.8l0.5,4.9l1.4,4.3l0.5,6.5"
                        />
                      </g>

                      <g>
                        <title>Iowa</title>
                        <path
                          v-on:click="clickState('IA')"
                          id="IA"
                          data-info="<div>State: Iowa</div><div>Capital: Des Moines</div>"
                          fill="#7C7C81"
                          d="M740.6,301.6l0.2,1.9l2.3,1.1l1.1,1.3l0.3,1.3l3.9,3.2l0.7,2.2l-0.8,2.9l-1.5,3.5l-0.8,2.7   l-2.2,1.6l-1.7,0.6l-5.5,1.5l-0.7,2.3l-0.8,2.3l0.6,1.4l1.7,1.7l0,3.7l-2.2,1.6l-0.5,1.5v2.5l-1.5,0.5l-1.7,1.4l-0.5,1.5l0.5,1.7   l-1.4,1.2l-2.3-2.7l-1.5-2.6l-8.3,0.8l-10.2,0.6l-25,0.7l-13,0.2l-9.4,0.2l-1.3,0.1l-1.7-4.5l-0.2-6.6l-1.6-4.1l-0.7-5.3l-2.3-3.7   l-0.9-4.8l-2.7-7.5l-1.1-5.4l-1.4-2.2l-1.6-2.7l1.8-4.3l1.4-5.7l-2.7-2.1l-0.5-2.7l0.9-2.5h1.7h11.5l49.6-0.7l19.9-0.7l1.9,2.7   l1.8,2.6l0.5,0.8l-1.8,2.7l0.5,4.2l2.5,3.9l3,1.8l2.4,0.2L740.6,301.6z"
                        />
                      </g>

                      <g>
                        <title>Mississippi</title>
                        <path
                          v-on:click="clickState('MS')"
                          id="MS"
                          data-info="<div>State: Mississippi</div><div>Capital: Jackson</div>"
                          fill="#7C7C81"
                          d="M798.6,567l-0.3,1.3h-5.2l-1.5-0.8l-2.1-0.3l-6.8,1.9l-1.8-0.8l-2.6,4.2l-1.1,0.8l-1.1-2.5   l-1.1-3.9l-3.4-3.2l1.1-7.5l-0.7-0.9l-1.8,0.2l-8.2,0.7l-24.2,0.7l-0.5-1.6l0.7-8l3.4-6.2l5.3-9.1l-0.9-2.1h1.1l0.7-3.2l-2.3-1.8   l0.2-1.8l-2.1-4.6l-0.3-5.3l1.4-2.7l-0.4-4.3l-1.4-3l1.4-1.4l-1.4-2.1l0.5-1.8l0.9-6.2l3-2.7l-0.7-2.1l3.7-5.3l2.7-0.9v-2.5   l-0.7-1.4l2.7-5.3l2.7-1.1l0.1-3.4l8.7-0.1l24.1-1.9l4.6-0.2l0,6.4l0.2,16.7l-0.8,31l-0.2,14.1l2.7,18.8L798.6,567z"
                        />
                      </g>

                      <g>
                        <title>Indiana</title>
                        <path
                          v-on:click="clickState('IN')"
                          id="IN"
                          data-info="<div>State: Indiana</div><div>Capital: Indianapolis</div>"
                          fill="#7C7C81"
                          d="M792.4,400.9l0.1-2.9l0.5-4.5l2.3-2.9l1.8-3.9l2.6-4.2l-0.5-5.8l-1.8-2.7l-0.3-3.2l0.8-5.5l-0.5-7   l-1.3-16l-1.3-15.4l-1-11.7l3.1,0.9l1.5,1l1.1-0.3l2.1-1.9l2.8-1.6l5.1-0.2l22-2.3l5.6-0.5l1.5,16l4.3,36.8l0.6,5.8L843,371   l1.2,1.8l0.1,1.4l-2.5,1.6l-3.5,1.6l-3.2,0.6l-0.6,4.9l-4.6,3.3l-2.8,4l0.3,2.4l-0.6,1.5h-3.3l-1.6-1.6l-2.5,1.3l-2.7,1.5l0.2,3.1   l-1.2,0.3l-0.5-1l-2.2-1.5l-3.3,1.3l-1.6,3l-1.4-0.8l-1.5-1.6l-4.5,0.5l-5.6,1L792.4,400.9z"
                        />
                      </g>

                      <g>
                        <title>Illinois</title>
                        <path
                          v-on:click="clickState('IL')"
                          id="IL"
                          data-info="<div>State: Illinois</div><div>Capital: Springfield</div>"
                          fill="#7C7C81"
                          d="M791.8,401.6V398l0.3-4.9l2.4-3.1l1.8-3.8l2.6-3.9l-0.4-5.3l-2-3.5l-0.1-3.3l0.7-5.3l-0.8-7.2   l-1.1-15.8l-1.3-15l-0.9-11.6l-0.3-0.9l-0.8-2.6l-1.3-3.7l-1.6-1.8l-1.5-2.6l-0.2-5.5l-9.9,1.3l-27.2,1.7l-8.7-0.4l0.2,2.4l2.3,0.7   l0.9,1.1l0.5,1.8l3.9,3.4l0.7,2.3l-0.7,3.4l-1.8,3.7l-0.7,2.5l-2.3,1.8l-1.8,0.7l-5.3,1.4l-0.7,1.8L736,330l0.7,1.4l1.8,1.6   l-0.2,4.1l-1.8,1.6l-0.7,1.6v2.7l-1.8,0.5l-1.6,1.1l-0.2,1.4l0.2,2.1l-1.7,1.3l-1,2.8l0.5,3.7l2.3,7.3l7.3,7.5l5.5,3.7l-0.2,4.3   l0.9,1.4l6.4,0.5l2.7,1.4l-0.7,3.7l-2.3,5.9l-0.7,3.2l2.3,3.9l6.4,5.3l4.6,0.7l2.1,5l2.1,3.2l-0.9,3l1.6,4.1l1.8,2.1l1.9-0.8   l0.7-2.2l2-1.4l3.2-1.1l3.1,1.2l2.9,1.1l0.8-0.2l-0.1-1.2l-1.1-2.8l0.4-2.4l2.3-1.6l2.4-1l1.2-0.4l-0.6-1.3l-0.8-2.2l1.2-1.3   L791.8,401.6z"
                        />
                      </g>

                      <g>
                        <title>Minnesota</title>
                        <path
                          v-on:click="clickState('MN')"
                          id="MN"
                          data-info="<div>State: Minnesota</div><div>Capital: Saint Paul</div>"
                          fill="#7C7C81"
                          d="M645.9,228.5l-0.5-8.5l-1.8-7.3l-1.8-13.5l-0.5-9.8l-1.8-3.4l-1.6-5v-10.3l0.7-3.9l-1.8-5.5l30.1,0   l0.3-8.2l0.6-0.2l2.3,0.5l1.9,0.8l0.8,5.5l1.5,6.1l1.6,1.6h4.8l0.3,1.5l6.3,0.3v2.1h4.8l0.3-1.3l1.1-1.1l2.3-0.6l1.3,1h2.9l3.9,2.6   l5.3,2.4l2.4,0.5l0.5-1l1.5-0.5l0.5,2.9l2.6,1.3l0.5-0.5l1.3,0.2v2.1l2.6,1h3.1l1.6-0.8l3.2-3.2l2.6-0.5l0.8,1.8l0.5,1.3h1l1-0.8   l8.9-0.3l1.8,3.1h0.6l0.7-1.1l4.4-0.4l-0.6,2.3l-3.9,1.8l-9.2,4.1l-4.8,2l-3.1,2.6l-2.4,3.6l-2.3,3.9l-1.8,0.8l-4.5,5l-1.3,0.2   l-3.8,2.9l-2.8,3.2l-0.2,3l0.2,7.8l-1.6,1.6L704,228l-1.8,5.7l2.5,3.6l0.5,2.5l-1.1,3l-0.2,3.7l0.5,7.1l3.4,4.1h3l2.5,2.3l3.2,1.4   l3.7,5l7.1,5l1.8,2.1l0.2,5.5l-20.6,0.7l-60.2,0.5l-0.3-35.7l-0.5-3l-4.1-3.4l-1.1-1.8v-1.6l2.1-1.6l1.4-1.4L645.9,228.5z"
                        />
                      </g>

                      <g>
                        <title>Wisconsin</title>
                        <path
                          v-on:click="clickState('WI')"
                          id="WI"
                          data-info="Wisconsin"
                          fill="#7C7C81"
                          d="M786.9,297.2l0.4-3l-1.6-4.5l-0.6-6.1l-1.1-2.4l1-3.1l0.8-2.9l1.5-2.6l-0.6-3.4l-0.6-3.6l0.5-1.8   l1.9-2.4l0.2-2.7l-0.8-1.3l0.6-2.6l0.5-3.2l2.7-5.7l2.9-6.8l0.2-2.3l-0.3-1l-0.8,0.5l-4.2,6.3l-2.7,4l-1.9,1.8l-0.8,2.3l-1.5,0.8   l-1.1,1.9l-1.5-0.3l-0.2-1.8l1.3-2.4l2.1-4.7l1.8-1.6l1.1-2.3l-1.6-0.9l-1.4-1.4l-1.6-10.3l-3.7-1.1l-1.4-2.3l-12.6-2.7l-2.5-1.1   l-8.2-2.3l-8.2-1.1l-4.2-5.4l-0.5,1.3l-1.1-0.2l-0.6-1.1l-2.7-0.8l-1.1,0.2l-1.8,1l-1-0.6l0.6-1.9l1.9-3.1l1.1-1.1l-1.9-1.5   l-2.1,0.8l-2.9,1.9l-7.4,3.2l-2.9,0.6l-2.9-0.5l-1-0.9l-2.1,2.8l-0.2,2.7v8.5l-1.1,1.6l-5.3,3.9l-2.3,5.9l0.5,0.2l2.5,2.1l0.7,3.2   l-1.8,3.2v3.9l0.5,6.6l3,3h3.4l1.8,3.2l3.4,0.5l3.9,5.7l7.1,4.1l2.1,2.7l0.9,7.4l0.7,3.3l2.3,1.6l0.2,1.4l-2.1,3.4l0.2,3.2l2.5,3.9   l2.5,1.1l3,0.5l1.3,1.4l9.2,0l26.1-1.5L786.9,297.2z"
                        />
                      </g>

                      <g>
                        <title>Missouri</title>
                        <path
                          v-on:click="clickState('MO')"
                          id="MO"
                          data-info="<div>State: Missouri</div><div>Capital: Jefferson City</div>"
                          fill="#7C7C81"
                          d="M729.8,349.5l-2.5-3.1l-1.1-2.3l-7.8,0.7l-9.8,0.5l-25.4,0.9l-13.5,0.2l-7.9,0.1l-2.3,0.1l1.3,2.5   l-0.2,2.3l2.5,3.9l3.1,4.1l3.1,2.7l2.3,0.2l1.4,0.9v3l-1.8,1.6l-0.5,2.3l2.1,3.4l2.5,3l2.5,1.8l1.4,11.7l-0.7,35.3l0.2,4.7l0.5,5.4   l23.4-0.1l23.2-0.7l20.8-0.8l11.7-0.2l2.2,3.4l-0.7,3.3l-3.1,2.4l-0.6,1.8l5.4,0.5l3.9-0.7l1.7-5.5l0.7-5.9l2.3-2l1.7-1.5l2.1-1   l0.1-2.9l0.6-1.7l-1-1.7l-2.7,0.1l-2.2-2.6l-1.4-4.2l0.8-2.5l-1.9-3.4l-1.8-4.6l-4.8-0.8l-7-5.6l-1.7-4.1l0.8-3.2l2.1-6.1l0.5-2.9   l-1.9-1l-6.9-0.8l-1-1.7l-0.1-4.2l-5.5-3.4l-7-7.8l-2.3-7.3l-0.2-4.2L729.8,349.5z"
                        />
                      </g>

                      <g>
                        <title>Arkansas</title>
                        <path
                          v-on:click="clickState('AR')"
                          id="AR"
                          data-info="<div>State: Arkansas</div><div>Capital: Little Rock</div>"
                          fill="#7C7C81"
                          d="M765,445l-3.8,0.9l-6.2-0.5l0.7-3l3.2-2.7l0.5-2.3l-1.8-3l-11,0.5l-20.8,0.9l-23.3,0.7L679,437   l1.6,6.9v8.2l1.4,11l0.2,37.8l2.3,1.9l3-1.4l2.7,1.1l0.4,10.3l22.9-0.1l18.9-0.8l10.1-0.2l1.1-2.1l-0.3-3.5l-1.8-3l1.6-1.5   l-1.6-2.5l0.7-2.5l1.4-5.6l2.5-2.1l-0.7-2.3l3.7-5.4l2.7-1.4l-0.1-1.5l-0.3-1.8l2.9-5.6l2.4-1.3l0.4-3.4l1.8-1.2l0.9-4.2l-1.3-4   l4-2.4l0.6-2l1.2-4.3L765,445z"
                        />
                      </g>

                      <g>
                        <title>Oklahoma</title>
                        <path
                          v-on:click="clickState('OK')"
                          id="OK"
                          data-info="<div>State: Oklahoma</div><div>Capital: Oklahoma City</div>"
                          fill="#7C7C81"
                          d="M549.3,422.6l-10.7-0.5l-6.4-0.5l0.3,0.2l-0.7,10.4l22,1.4l32.1,1.3l-2.3,24.4l-0.5,17.8l0.2,1.6   l4.3,3.7l2.1,1.1l0.7-0.2l0.7-2.1l1.4,1.8h2.1v-1.4l2.7,1.4l-0.5,3.9l4.1,0.2l2.5,1.1l4.1,0.7l2.5,1.8l2.3-2.1l3.4,0.7l2.5,3.4h0.9   v2.3l2.3,0.7l2.3-2.3l1.8,0.7h2.5l0.9,2.5l4.8,1.8l1.4-0.7l1.8-4.1h1.1l1.1,2.1l4.1,0.7l3.7,1.4l3,0.9l1.8-0.9l0.7-2.5h4.3l2.1,0.9   l2.7-2.1h1.1l0.7,1.6h4.1l1.6-2.1l1.8,0.5l2.1,2.5l3.2,1.8l3.2,0.9l1.9,1.1l-0.4-37.2l-1.4-11l-0.2-8.9l-1.4-6.5l-0.8-7.2l-0.1-3.8   l-12.1,0.3l-46.4-0.5l-45-2.1L549.3,422.6z"
                        />
                      </g>

                      <g>
                        <title>Kansas</title>
                        <path
                          v-on:click="clickState('KS')"
                          id="KS"
                          data-info="<div>State: Kansas</div><div>Capital: Topeka</div>"
                          fill="#7C7C81"
                          d="M677.4,425.1l-12.6,0.2l-46.1-0.5l-44.6-2.1l-24.6-1.3l4.1-64.7l21.8,0.8l40.5,1.4l44.1,0.5h5.1   l3.2,3.2l2.8,0.2l0.9,1.1v2l-1.8,1.6l-0.5,2.6l2.2,3.6l2.5,3.1l2.5,2l1.1,11.2L677.4,425.1z"
                        />
                      </g>

                      <g>
                        <title>Louisiana</title>
                        <path
                          v-on:click="clickState('LA')"
                          id="LA"
                          data-info="<div>State: Louisiana</div><div>Capital: Baton Rouge</div>"
                          fill="#7C7C81"
                          d="M776.2,573l-1-2.6l-1.1-3.1l-3.3-3.5l0.9-6.8l-0.1-1.1l-1.3,0.3l-8.2,0.9l-25,0.5l-0.7-2.4l0.9-8.5   l3.3-5.9l5-8.7l-0.6-2.4l1.3-0.7l0.5-2l-2.3-2.1l-0.1-1.9l-1.8-4.3l-0.5-5.9l-9.7,0.1l-19.2,0.9l-22.2,0l0,9.6l0.7,9.4l0.7,3.9   l2.5,4.1l0.9,5l4.3,5.5l0.2,3.2l0.7,0.7l-0.7,8.5l-3,5l1.6,2.1l-0.7,2.5l-0.7,7.3l-1.4,3.2l0.1,3.6l4.7-1.5l8.1-0.3l10.3,3.6   l6.5,1.1l3.7-1.5l3.2,1.1l3.2,1l0.8-2.1l-3.2-1.1l-2.6,0.5l-2.7-1.6c0,0,0.2-1.3,0.8-1.5c0.6-0.2,3.1-1,3.1-1l1.8,1.5l1.8-1   l3.2,0.6l1.5,2.4l0.3,2.3l4.5,0.3l1.8,1.8l-0.8,1.6l-1.3,0.8l1.6,1.6l8.4,3.6l3.6-1.3l1-2.4l2.6-0.6l1.8-1.5l1.3,1l0.8,2.9   l-2.3,0.8l0.6,0.6l3.4-1.3l2.3-3.4l0.8-0.5l-2.1-0.3l0.8-1.6l-0.2-1.5l2.1-0.5l1.1-1.3l0.6,0.8c0,0-0.2,3.1,0.6,3.1   c0.8,0,4.2,0.6,4.2,0.6l4,1.9l1,1.5h2.9l1.1,1l2.3-3.1v-1.5h-1.3l-3.4-2.7l-5.8-0.8l-3.2-2.3l1.1-2.7l2.3,0.3l0.2-0.6l-1.8-1v-0.5   h3.2l1.8-3.1l-1.3-1.9l-0.3-2.7l-1.5,0.2l-1.9,2.1l-0.6,2.6l-3.1-0.6l-1-1.8l1.8-1.9l2-1.8L776.2,573z"
                        />
                      </g>

                      <g>
                        <title>Virginia</title>
                        <path
                          v-on:click="clickState('VA')"
                          id="VA"
                          data-info="<div>State: Virginia</div><div>Capital: Richmond</div>"
                          fill="#7C7C81"
                          d="M1002.9,369.2l-0.1-1.9l6.5-2.5l-0.8,3.2l-2.9,3.8l-0.4,4.6l0.5,3.4l-1.8,5l-2.2,1.9l-1.5-4.6   l0.4-5.4l1.6-4.2L1002.9,369.2z M1005.2,397.5L947,410.1l-37.4,5.3l-6.7-0.4l-2.6,1.9l-7.3,0.2l-8.4,1l-8.9,1l8.5-4.9l0-2.1   l1.5-2.1l10.6-11.5l3.9,4.5l3.8,1l2.5-1.1l2.2-1.3l2.5,1.3l3.9-1.4l1.9-4.6l2.6,0.5l2.9-2.1l1.8,0.5l2.8-3.7l0.3-2.1l-1-1.3l1-1.9   l5.3-12.3l0.6-5.7l1.2-0.5l2.2,2.4l3.9-0.3l1.9-7.6l2.8-0.6l1-2.7l2.6-2.3l1.3-2.3l1.5-3.4l0.1-5.1l9.8,3.8   c0.7,0.3,0.7-4.8,0.7-4.8l4.1,1.4l-0.5,2.6l8.2,2.9l1.3,1.8l-0.9,3.7l-1.3,1.3l-0.5,1.7l0.5,2.4l2,1.3l3.9,1.4l2.9,1l4.9,0.9   l2.2,2.1l3.2,0.4l0.9,1.2l-0.4,4.7l1.4,1.1l-0.5,1.9l1.2,0.8l-0.2,1.4l-2.7-0.1l0.1,1.6l2.3,1.5l0.1,1.4l1.8,1.8l0.5,2.5l-2.6,1.4   l1.6,1.5l5.8-1.7L1005.2,397.5z"
                        />
                      </g>

                      <g id="DC">
                        <title>Washington DC</title>
                        <path
                          id="path58"
                          fill="#7C7C81"
                          d="M975.8,353.8l-1.1-1.6l-1-0.8l1.1-1.6l2.2,1.5L975.8,353.8z"
                        />
                        <circle
                          id="circle60"
                          data-info="<div>Washington DC</div>"
                          fill="#7C7C81"
                          stroke="#FFFFFF"
                          stroke-width="1.5"
                          cx="975.3"
                          cy="351.8"
                          r="5"
                        />
                      </g>
                    </g>
                  </svg>
                  <button class="show-all-btn" @click="openACWindow">
                    <i data-v-2b6942c0 class="material-icons">clear_all</i>
                    Show All ACs
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col col-12">
                <div
                  class="
                    nav-btns
                    listing-header
                    d-flex
                    align-items-center
                    p-3
                    mt10
                    mb10
                    rounded
                    b-shadow
                  "
                >
                  <button v-if="this.step === 1" disabled class="mrauto">
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-else
                    @click.prevent="setPage(step - 1)"
                    class="mrauto"
                  >
                    <i class="material-icons">keyboard_arrow_left</i> Back
                  </button>

                  <button
                    v-if="

                      this.userState == '' ||
                      this.County == '' ||
                      this.ACnotes == '' ||
                      this.acFilter == null ||
                      this.PrimaryContactName == '' ||
                      this.conversationDate == '' ||
                      this.submitting
                    "
                    class="mlauto"
                    disabled
                  >
                    Submit
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>

                  <button v-else class="mlauto" @click="submitITproj">
                    Submit
                    <i class="material-icons">keyboard_arrow_right</i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import { AtomSpinner } from "epic-spinners";
import { HollowDotsSpinner } from "epic-spinners";
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'


// import Avatar from "vue-avatar";
// import Datepicker from "vuejs-datepicker";
// import Multiselect from "vue-multiselect";

import vSelect from "vue-select";
// import "vue-multiselect/dist/vue-multiselect.min.css";
// import "vue-select/dist/vue-select.css";

// import "animate.css";

const auth = {
  headers: {
    Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    //Authorization: "Bearer " + wontworkqwd2iwedjqoewiudwo
  },
};

export default {
  name: "InterterritorialAdd",
  components: {
    AtomSpinner,
    VueDatePicker,
    // Multiselect,
    HollowDotsSpinner,
    vSelect
  },
  data() {
    return {
      submitting: false,
      step: 1,
      totalPage: 5,
      statemax: 2,
      ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
      server: import.meta.env.VITE_APP_SERVER_URL,
      backend: import.meta.env.VITE_APP_SERVER_URL,
      storedListings: [],
      acs: [],
      salespeople: [],
      leadtimes: [],
      selectedCat: "Show All",
      acFilter: null,
      searching: false,
      loading: true,
      noRGAFound: false,
      percentage: "10%",
      MarketSelection: null,
      skip2and3: false,
      dupcompname: false,
      foundZip: false,

      userCompanyName: "",
      userContactName: "",
      userAddress: "",
      userCity: "",
      userState: "",
      userZip: "",
      userPhone: "",
      userEmail: "",

      architectCompanyName: "",
      architectContactName: "",
      architectAddress: "",
      architectCity: "",
      architectState: "",
      architectZip: "",
      architectPhone: "",
      architectEmail: "",

      contractorCompanyName: "",
      contractorContactName: "",
      contractorAddress: "",
      contractorCity: "",
      contractorState: "",
      contractorZip: "",
      contractorPhone: "",
      contractorEmail: "",

      jobName: "",
      jobDesc: "",
      jobMarket: null,
      SSCNetValue: null,
      productTypes: [],
      orderDate: "",
      shipDate: "",
      leadSalesPerson: null,
      acList: null,
      State: "",
      County: "",
      AC: "",
      productTypes: [],
      ACnotes: "",
      conversationDate: "",
      PrimaryContactName: "",
      /*
      productTypes: [
        { name: "4-POST" },
        { name: "ACTIVESTOR" },
        { name: "Art Rack" },
        { name: "CANTILEVER" },
        { name: "DOORS & DRAWERS" },
        { name: "Eclipse" },
        { name: "Evidence Locker" },
        { name: "FIREARM STO" },
        { name: "FrameWRX" },
        { name: "GUN RACKS" },
        { name: "LATERALS" },
        { name: "Manual" },
        { name: "Mech Assist" },
        { name: "MUSEUM CASES" },
        { name: "OTHER" },
        { name: "Personal Duty Locker" },
        { name: "Powered System" },
        { name: "QUICKSPACE" },
        { name: "ROTARY FILE" },
        { name: "Series 16" },
        { name: "Series 60" },
        { name: "Series 8" },
        { name: "TECHNIBILT" },
        { name: "Wheelhouse" },
        { name: "Wheelhouse Electric" },
        { name: "WIDESPAN" },
        { name: "XTEND - Shelving" },
	  ],
	  */
      productTypesSelected: [],
      productTypesFormatted: [],
      acid: null,
    };
  },
  methods: {
    firstLoad: function () {
      this.loading = true;
      this.$store.commit("setActivePage", "order-manage");
      //return axios.get(this.endPointCompute, auth).then((response) => {
      return axios
        .get(`${this.ordermanageapi}/aclist?all=yes&active=true`, auth)
        .then((response, acs) => {
          //console.log(response);
          this.acs = response.data;
          this.loading = false;
        })

        .then(() => {
          return axios

            .get(`${this.ordermanageapi}/salespeople`, auth)
            .then((response, salespeople) => {
              //console.log(response);
              this.salespeople = response.data.salesPeople;
              this.loading = false;
            });
        })
        .then(() => {
          return axios

            .get(`${this.ordermanageapi}/options?type=ptypes`, auth)
            .then((response, productTypes) => {
              console.log(response, productTypes);
              this.productTypes = response.data.productTypes;
              this.loading = false;
            });
        })
        .then(() => {
          return axios

            .get(`${this.server}/api/v1/ac-territories`, auth)
            .then((response) => {
              if (response.status === 401) {
                console.log("not allowed");
              } else {
                //console.log(response);
                this.acList = response.data.aCDistributors;
              }
            });
        });
    },
    removeDollarSign: function () {
      if (this.SSCNetValue != null) {
        //console.log("removing");
        this.SSCNetValue = this.SSCNetValue.replaceAll("$", "").replaceAll(",", "");
      }
    },
    cleanPhoneNumbers: function () {
      if (this.userPhone.length) {
        //console.log("removing");
        this.userPhone = this.userPhone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "");
      }
      if (this.architectPhone.length) {
        //console.log("removing");
        this.architectPhone = this.architectPhone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "");
      }
      if (this.contractorPhone.length) {
        //console.log("removing");
        this.contractorPhone = this.contractorPhone.replaceAll("(", "").replaceAll(")", "").replaceAll("-", "");
      }
      
      
      
    },

    resetZip() {
      this.foundZip = false;
    },

    checkZip() {
      return axios
        .get(`${this.server}/api/v1/ac-zip/${this.userZip}`, auth)
        .then((response) => {
          // this checks on step 2 and 4
          console.log(response);
          if (response.data.length) {
            this.foundZip = true;
            let selected = response.data[0].ACID;
            this.acs.filter;
            let found = this.acs.filter((ac) => ac.acid === selected);
            console.log(found);
            this.acFilter = found[0];
          } else {
            this.acFilter = null;
            this.foundZip = false;
          }
        });
    },

    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    setPage: function (idx) {
      document.activeElement.blur();
      if (idx <= 0 || idx > this.totalPage) {
        return;
      }
      document
        .getElementById("mobileScrollTarget")
        .scrollIntoView({ behavior: "smooth" });
      this.step = idx;
    },
    openACWindow: function () {
      window.open("/ac-list", "_blank");
    },
    submitITproj() {
      //console.log("submitted");
      this.submitting = true;
      var thePostDate = new Date();
      let axiosConfig = {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
        },
      };
      let postData = {
        isActive: true,
        submitDate: thePostDate,
        submitter: this.$store.state.user.UserId,
        hasSpecs: false,
        marketId: this.MarketSelection,
        installNotes: this.ACnotes,
        jobDescription: this.jobDesc,
        jobName: this.jobName,
        sscnetValue: this.SSCNetValue,
        orderDate: this.orderDate,
        shipDate: this.shipDate,
        endUserName: this.userContactName,
        architectName: this.architectContactName,
        contractorName: this.contractorContactName,
        leadSalesPerson: this.leadSalesPerson,
        installationAcid: this.acFilter.acid,
        submitterAcid: this.$store.state.user.ACId[0],
        conversationDate: this.conversationDate,
        primaryContact: this.PrimaryContactName,
        EndUserAddress: {
          addressName: "End User",
          CompanyName: this.userCompanyName,
          address1: this.userAddress,
          City: this.userCity,
          State: this.userState,
          ZipCode: this.userZip,
          Phone: this.userPhone,
          Email: this.userEmail,
        },
        ArchitectAddress: {
          addressName: "Architect",
          CompanyName: this.architectCompanyName,
          address1: this.architectAddress,
          City: this.architectCity,
          State: this.architectState,
          ZipCode: this.architectZip,
          Phone: this.architectPhone,
          Email: this.architectEmail,
        },
        ContractorAddress: {
          addressName: "Contractor",
          CompanyName: this.contractorCompanyName,
          address1: this.contractorAddress,
          City: this.contractorCity,
          State: this.contractorState,
          ZipCode: this.contractorZip,
          Phone: this.contractorPhone,
          Email: this.contractorEmail,
        },
        InstallAddress: {
          addressName: "Installation",
          CompanyName: this.userCompanyName,
          address1: this.userAddress,
          City: this.userCity,
          State: this.userState,
          ZipCode: this.userZip,
          County: this.County,
          Phone: this.userPhone,
          Email: this.userEmail,
        },
        itjobProducts: this.productTypesSelected,
      };

      //console.log(JSON.stringify(postData))

      // sn3itjobProducts: this.productTypesSelected,
      //console.log(postData);
      axios.post(`${this.ordermanageapi}/itproj`, postData, axiosConfig).then(
        (response) => {
          //console.log(response);
          const returnedID = response.data.id;
          let emailData = {
            itProjNum: response.data.id,
            jobName: this.jobName,
            location: this.userCompanyName,
            state: this.userState,
            city: this.userCity,
            comment: this.ACnotes,
            link: `http://spacenet3.spacesaver.com/interterritorial/${response.data.id}`,
            contact: this.acFilter.email,
          };

          if (this.acFilter.email) {
            
            return axios
              .post(
                `${this.server}/api/v1/new-itproj-email`,
                emailData,
                axiosConfig
              )
              .then(() => {
                //console.log("Successfully created a new email notification");
                this.$toast.success(
                  "Successfully created a new interterritorial project!"
                );
                this.$router.push(`/interterritorial/${returnedID}`);
              })
              .catch((err) => {
                //console.log(err);
                this.$toast.error(
                  "Sorry, there was an issue making a new email notification"
                );
              });
              
          } else {
            this.$router.push(`/interterritorial/${returnedID}`);
            this.$toast.error(
              "No email notification was sent due to lack of primary contact at Area Contractor"
            );
          }
        },
        (error) => {
          console.log(error);
        }
      );
      this.submitting = false;
    },
  },
  computed: {
    activeNav() {
      return this.$store.state.activePage;
    },

    colorGetter() {
      return this.$store.state.colors;
    },

    progressWidth: function () {
      let className = "first-step";
      if (this.step == 1) {
        let className = "first-step";
        return className;
      } else if (this.step == 2) {
        let className = "second-step";
        return className;
      } else if (this.step == 3) {
        let className = "third-step";
        return className;
      } else if (this.step == 4) {
        let className = "fourth-step";
        return className;
      } else if (this.step == 5) {
        this.removeDollarSign();
        this.cleanPhoneNumbers();
        let className = "fifth-step";
        return className;
      }
    },
    progressWidthComplex: function () {
      let className = "zero";
      if (this.step == 1) {
        let className = "first-step";
        return className;
      } else if (this.step == 2) {
        let className = "second-step";
        return className;
      } else if (this.step == 3) {
        let className = "third-step";
        return className;
      } else if (this.step == 4) {
        let className = "fourth-step";
        return className;
      } else if (this.step == 5) {
        let className = "fifth-step";
        return className;
      }
    },
    progressPercentage: function () {
      if (this.step == 1) {
        return "10%";
      } else if (this.step == 2) {
        this.checkZip();
        return "30%";
      } else if (this.step == 3) {
        return "50%";
      } else if (this.step == 4) {
        if (this.dupcompname && this.userCompanyName != "") {
          this.jobName = this.userCompanyName;
        }
        this.checkZip();
        return "80%";
      } else if (this.step == 5) {
        return "90%";
      }
    },
    companyID() {
      let number = this.$store.state.user.ACId[0];
      this.acid = number;
    },

    copyCompanyName: function () {},

    states() {
      return new Set(this.acList.map((x) => x.State).sort());
    },

    byStateList() {
      // If that's the intention, you can do a check on the variable called 'found'. If it is empty you can delete the entry from the copy.
      // Make a copy so you don't ruin the original data
      const copy = Object.assign(this.acList, {});
      let found;

      copy.forEach((entry) => {
        if (this.userState && this.userState.length && this.County == "") {
          found = entry.ACDistributorRegions.filter(
            (region) => region.RegionGroupName === this.userState
          );
        }

        if (this.userState && this.userState.length && this.County != "") {
          found = entry.ACDistributorRegions.filter(
            (region) =>
              region.RegionGroupName === this.userState &&
              region.RegionName.toLowerCase() == this.County.toLowerCase()
          );
        }

        //entry.ACDistributorRegions.filter(region => region.RegionGroupName.includes(this.County.toLowerCase()));

        //RegionName
        // Replace the current list with the filtered list
        entry.Regions = found;
      });

      return copy.filter((entry) => entry.Regions.length > 0);
    },
  },
  created() {
    this.$store.commit("showNavigation");
    // console.log(this.$route.path);
  },

  mounted() {
    this.firstLoad();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#pickDate1 input {
  border: 0 !important;
  outline: none !important;
}

.btn-primary:not(:disabled):not(.disabled).active,
.btn-primary:not(:disabled):not(.disabled):active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #00b4b4;
  border-color: #00b4b4;
}

.leadTime {
  background-color: #fff;
  line-height: 44px;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}
.top-wrap {
  display: flex;
  align-items: flex-start;
}
.leadTime-bottom {
  align-items: flex-end;
}
.leadTime-header {
  background: #fff;
  color: #575757;
  display: flex !important;
}
.small-lh {
  line-height: 1.4em;
}

.listing {
  overflow: none;
}

.listing {
  background-color: #fff;
  line-height: 1;
  padding: 20px;
  margin-bottom: 5px;
  border-top: 0;
}

.table-responsive {
  display: table;
}
.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.03) !important;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #e8e8e8 !important;
}
.badge-success {
  color: #fff;
  background-color: #4d5967;
  background-color: #1eb5b6;
}
.table-striped a {
  color: #00b4b4;
}
.table-striped td,
.table-striped th {
  padding: 5px;
  font-weight: 300 !important;
}
.listing {
  border-radius: 4px;
}
table td {
  line-height: 1;
}
.table-striped th {
  background: #00b4b4;
  background: #4d5967;
  color: #fff;
}
.table-striped {
  min-width: 100%;
  overflow: scroll;
}
.search-btns {
  display: flex;
  margin-top: 10px;
  margin-bottom: 10px;
}
.search-btns button {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: #4d5967;
  color: #fff;
  border-radius: 4px;
  padding: 5px;
  cursor: pointer;
  max-height: 40px;
}
.search-btns .clear {
  margin-left: auto;
}
.search-btns .search {
  margin-left: 5px;
}
.search-btns button span {
  font-size: 20px;
  width: 20px;
  height: 20px;
  color: #fff;
}
.search-btns button:hover {
  background: #586575;
}
.search-btns button:active {
  background: #586575;
}
.search-btns button:disabled {
  opacity: 0.6;
  cursor: unset !important;
}
.search-btns button:disabled:hover {
  background: #4d5967;
}
.search-btns button:disabled:active {
  background: #4d5967;
}

@media all and (min-width: 768px) {
  .dates {
    display: flex;
    color: #757575 !important;
  }
}
.top-search {
  color: #757575;
}
select.form-control:not([size]):not([multiple]) {
  height: auto !important;
  padding: 10px !important;
  color: #757575;
}
.all-contractors {
  color: #757575 !important;
}
.header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.table-striped td:last-of-type {
  text-align: right;
}
.table-striped th:last-of-type {
  text-align: right;
}
.table-bordered td:first-of-type {
  border-right: none !important;
}
.table-bordered th:first-of-type {
  border-right: none !important;
}
.table-bordered td:last-of-type {
  border-left: none !important;
}
.table-bordered th:last-of-type {
  border-left: none !important;
}
.m50 {
  margin: 50px 0;
}
.nav-btns {
  display: flex;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-leave-active,
.slide-enter-active {
  transition: 1s;
}
.slide-enter {
  transform: translate(100%, 0);
}
.slide-leave-to {
  transform: translate(-100%, 0);
}
.listing-header {
  background: #fff;
  color: #575757;
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}
.loader {
  margin: 0 auto 20px;
  width: 100%;
  height: 25px;
  border-radius: 14px;
  border-bottom: 1px solid #fff;
  border-top: 1px solid #999;
  background: #ccc;
  overflow: hidden;
  position: relative;
}

.progress-bar {
  height: inherit;
  width: 0%;
  border-radius: inherit;
  position: relative;
  overflow: hidden;
}

.progress-stripes {
  width: inherit;
  height: inherit;
  font-size: 180px;
  font-weight: bold;
  margin-top: -50px;
  letter-spacing: -14px;
}

.percentage {
  position: absolute;
  top: 0;
  right: 5px;
  font-weight: bold;
  font-size: 16px;
}
/* PURPLE */
.teal .progress-bar {
  background: #00b4b4;
}
.teal .progress-stripes {
  color: #00b4b4;
}
.teal .percentage {
  color: #eee;
}
.first-step {
  width: 10%;
}
.second-step {
  width: 30%;
}
.third-step {
  width: 50%;
}
.fourth-step {
  width: 80%;
}
.fifth-step {
  width: 90%;
}
.teal {
  color: #00b4b4;
}
.lookup-wrapper {
  text-align: center;
}
.lookup-svg {
  width: 300px;
  height: auto;
  max-width: 300px;
  margin-left: auto;
  margin-right: auto;
  margin-right: auto;
  margin: 0 auto;
}
.show-all-btn {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border: none;
  /* background: #519bb2; */
  background: rgb(124, 124, 129);

  color: #fff;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 auto;
  margin-top: 20px;
}
.show-all-btn:hover {
  background: #4d5967;
}
.custom-control-label:before {
  background-color: #dedede;
}
.custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #00b4b4 !important;
}
</style>

<style>
.style-chooser .vs__selected{
      background-color: #00BCBC!important;
      color: #fff!important;
}
.style-chooser .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
}
.style-chooser .vs__selected-options{
  padding: 10px;
}
.style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
  background-color: #00BCBC!important;
  color: #fff!important;
}
.style-chooser .vs__deselect{
  fill: #fff;
}
.style-chooser .vs__selected{
  border: none;
  font-weight: 300;
  padding: 2px 10px;
}
.style-chooser .vs__dropdown-toggle{
  padding: 0;
}
.style-chooser .vs__search{
  margin: 0;
  padding: 0;
}
</style>